import * as SGCaptcha from '@byted/bric_verify_sec_sdk_build/captcha/sg';
import * as VACaptcha from '@byted/bric_verify_sec_sdk_build/captcha/va';
import * as INCaptcha from '@byted/bric_verify_sec_sdk_build/captcha/in';
import * as TTPCaptcha from '@byted/bric_verify_sec_sdk_build/captcha/ttp';
import sha256 from 'crypto-js/sha256';
import hex from 'crypto-js/enc-hex';
import axios from 'axios';
import verification from '@byted-sdk/tiktok-web-verification';
import isUri from 'isuri';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var URL_PREFIX = {
  AUTH: '/user_info',
  WEB: '/passport/web',
  APP: '/passport/mobile',
  SSO_AFF: '/aff',
  WEB_AFF: '/passport/aff/web',
  MOBILE_AFF: '/passport/aff/mobile',
  COMMON: '/passport/common'
};
var WEB_URL = {
  SEND_MOBILE_CODE: URL_PREFIX.WEB + "/send_code/",
  SEND_EMAIL_CODE: URL_PREFIX.WEB + "/email/send_code/",
  VERIFY_MOBILE_CODE: URL_PREFIX.WEB + "/validate_code/",
  VERIFY_EMAIL_CODE: URL_PREFIX.WEB + "/email/verify/",
  CHECK_MOBILE_CODE: URL_PREFIX.WEB + "/mobile/check_code/",
  CHECK_EMAIL_CODE: URL_PREFIX.WEB + "/email/check_code/",
  // login & register
  SMS_LOGIN: URL_PREFIX.WEB + "/sms_login/",
  SMS_LOGIN_ONLY: URL_PREFIX.WEB + "/sms_login_only/",
  SMS_LOGIN_CONTINUE: URL_PREFIX.WEB + "/sms_login_continue/",
  EMAIL_LOGIN: URL_PREFIX.WEB + "/email/login/",
  EMAIL_CODE_LOGIN: URL_PREFIX.WEB + "/email/code_login/",
  EMAIL_REGISTER_LOGIN: URL_PREFIX.WEB + "/email/register_verify_login/",
  EMAIL_REGISTER: URL_PREFIX.WEB + "/email/register_verify/",
  PWD_LOGIN: URL_PREFIX.WEB + "/user/login/",
  AUTH_LOGIN: URL_PREFIX.WEB + "/auth/login/",
  AUTH_LOGIN_ONLY: URL_PREFIX.WEB + "/auth/login_only/",
  AUTH_BIND_ONLY: URL_PREFIX.WEB + "/auth/bind_login/",
  MOBILE_BIND_ONLY: URL_PREFIX.WEB + "/mobile/bind_login/",
  MOBILE_EMAIL_REGISTER: URL_PREFIX.WEB + "/mobile_email_register/",
  MOBILE_REGISTER: '/passport/mobile/register/',
  MOBILE_OAUTH: '/passport/auth/show_oauth_mobile/',
  LOGOUT: URL_PREFIX.WEB + "/logout/",
  CHECK_LOGIN: '/passport/account/info/v2/',
  BIND_WITH_MOBILE_LOGIN: URL_PREFIX.WEB + "/auth/bind_with_mobile_login/",
  BIND_WITH_EMAIL_LOGIN: URL_PREFIX.WEB + "/auth/bind_with_email_login/",
  GET_QRCODE: URL_PREFIX.WEB + "/get_qrcode/",
  CHECK_QRCONNECT: URL_PREFIX.WEB + "/check_qrconnect/",
  SCAN_QRCODE: URL_PREFIX.WEB + "/scan_qrcode/",
  CONFIRM_QRCODE: URL_PREFIX.WEB + "/confirm_qrcode/",
  THIRD_AUTH: URL_PREFIX.WEB + "/web_login/",
  USERNAME_REGISTER: URL_PREFIX.WEB + "/username/register/",
  WEB_SHARE_LOGIN: URL_PREFIX.WEB + "/auth/share_login/",
  AUTH_LOGIN_URL: '/passport/auth/wap_login/',
  EMAIL_REGISTER_NO_VERIFY: URL_PREFIX.WEB + "/email/register/",
  EMAIL_REGISTER_NO_VERIFY_V2: URL_PREFIX.WEB + "/email/register/v2/",
  // bind
  MOBILE_BIND: URL_PREFIX.WEB + "/mobile/bind/",
  EMAIL_BIND: URL_PREFIX.WEB + "/email/bind/",
  AUTH_BIND: URL_PREFIX.WEB + "/auth/bind/",
  AUTH_UNBIND: URL_PREFIX.WEB + "/auth/unbind/",
  AUTH_SWITCH_BIND: URL_PREFIX.WEB + "/auth/switch_bind/",
  // rebind
  MOBILE_REBIND: URL_PREFIX.WEB + "/mobile/change/",
  EMAIL_REBIND: URL_PREFIX.WEB + "/email/change/",
  // forget password
  RESET_PWD_BY_MOBILE: URL_PREFIX.WEB + "/password/reset/",
  RESET_PWD_BY_EMAIL: URL_PREFIX.WEB + "/email/password/reset/",
  RESET_PWD_BY_MOBILE_TICKET: URL_PREFIX.WEB + "/password/reset_by_ticket/",
  FORCE_RESET_PWD_BY_MOBILE_TICKET: URL_PREFIX.WEB + '/password/forced_reset_by_mobile_ticket/',
  RESET_PWD_BY_EMAIL_TICKET: URL_PREFIX.WEB + "/password/reset_by_email_ticket/",
  FORCE_RESET_PWD_BY_EMAIL_TICKET: URL_PREFIX.WEB + '/password/forced_reset_by_email_ticket/',
  // password
  PWD_CHANGE_BY_MOBILE: URL_PREFIX.WEB + "/password/change/",
  PWD_UPDATE: URL_PREFIX.WEB + "/password/update/",
  PWD_CHANGE_BY_EMAIL: URL_PREFIX.WEB + "/email/change_password/",
  PWD_SET: URL_PREFIX.WEB + "/password/set/",
  PWD_HAS_SET: '/passport/password/has_set/',
  PWD_HAS_SET_V2: URL_PREFIX.WEB + "/password/has_set/",
  PWD_RESET_LOGIN_BY_EMAIL: URL_PREFIX.WEB + "/email/password/reset_and_login/",
  PWD_SET_BY_EAMIL_AND_LOGIN: URL_PREFIX.WEB + "/email/password/reset_and_login/",
  // verify
  ACCOUNT_VERIFY: URL_PREFIX.WEB + "/account/verify/",
  AUTH_VERIFY: URL_PREFIX.WEB + "/auth/verify/",
  SMS_AUTHORIZE: URL_PREFIX.WEB + "/sms/authorize/",
  AVAILABLE_WAYS: URL_PREFIX.WEB + "/auth/available_ways/",
  VERIFY_PWD_WITHOUT_LOGIN: URL_PREFIX.WEB + "/account/verify_pwd_without_login/",
  // cancel
  CANCEL_VERIFY_WAY: '/passport/auth/cancel_verify_way/',
  CANCEL_CHECK: URL_PREFIX.WEB + "/cancel/check/",
  CANCEL_CONFIRM: URL_PREFIX.WEB + "/cancel/confirm/",
  CANCEL_REQUEST: URL_PREFIX.WEB + "/cancel/post/",
  CANCEL_LOGIN: URL_PREFIX.WEB + "/cancel/login/",
  // extra
  CHECK_MOBILE_REGISTER: URL_PREFIX.WEB + "/user/check_mobile_registered/",
  // some paths without /
  CHECK_EMAIL_REGISTER: URL_PREFIX.WEB + "/user/check_email_registered",
  CHANGE_QRCODE_SUCCESS: '/passport/qrcode_twostep_verify/scan_qrcode/',
  CHANGE_QRCODE_CONFIRM: '/passport/qrcode_twostep_verify/confirm_by_ticket/',
  // open
  GET_OPEN_AUTH_INFO: '/passport/open/auth_info/v2/',
  OPEN_SEND_CODE: '/passport/open/send_code/',
  OPEN_SMS_AUTH: '/passport/open/web/sms/auth/',
  OPEN_ACCOUNT_AUTH: '/passport/open/web/account/auth/',
  OPEN_THIRD_AUTH: '/passport/open/web/third_party/auth/',
  OPEN_GET_QRCODE: '/passport/open/get_qrcode/',
  OPEN_CHECK_QRCODE: '/passport/open/check_qrcode',
  OPEN_TO_SCAN_QRCODE: '/passport/open/to_scan_qrcode/',
  OPEN_SCAN_QRCODE: '/passport/open/scan_qrcode/',
  OPEN_CONFIRM_QRCODE: '/passport/open/confirm_qrcode/',
  OPEN_WEB_AUTH: '/passport/open/web/auth/',
  // account
  ACCOUNT_INFO: URL_PREFIX.WEB + "/account/info/",
  ACCOUNT_SET: URL_PREFIX.WEB + "/account/set/",
  ACCOUNT_REGISTER_LOGIN_NAME: URL_PREFIX.WEB + "/login_name/register/",
  ACCOUNT_AUTH_CONFIG: URL_PREFIX.WEB + "/auth/config/",
  ACCOUNT_UPDATE_LOGIN_NAME: URL_PREFIX.WEB + "/login_name/update/",
  // user
  OAUTH_PROFILE: '/web/user/get/oauth_profile/',
  UPLOAD_AVATAR: '/web/user/update/upload_avatar/',
  UPDATE_USERINFO: '/web/user/update/user_info/',
  CHECK_DEFAULT_INFO: '/web/user/check/default_info/',
  GET_BACKGROUND_LIST: '/web/user/settings/{aid}/default_background_image_list/',
  GET_DEFAULT_AVATAR_LIST: '/web/user/settings/{aid}/default_avatar_list/',
  GET_RECOMMEND_NAME: '/web/user/settings/recommend_name/',
  UPLOAD_PICTURE: '/web/user/upload/pic/',
  CHECK_REMAIN_TIMES: '/web/user/get/remain_update_times/',
  DOWNLOAD_IMAGE: '/user/web/download/image/',
  DOWNLOAD_IMAGE_V2: '/user/web/download/image/v2/'
};
var WEB_AFF_URL = {
  SEND_MOBILE_CODE: URL_PREFIX.WEB_AFF + "/mobile/send_code/",
  SEND_EMAIL_CODE: URL_PREFIX.WEB_AFF + "/email/send_code/",
  VERIFY_MOBILE_CODE: URL_PREFIX.WEB_AFF + "/mobile/validate_code/",
  VERIFY_EMAIL_CODE: URL_PREFIX.WEB_AFF + "/email/verify/",
  CHECK_MOBILE_CODE: URL_PREFIX.WEB_AFF + "/mobile/check_code/",
  CHECK_EMAIL_CODE: URL_PREFIX.WEB_AFF + "/email/check_code/",
  // login
  SMS_LOGIN: URL_PREFIX.WEB_AFF + "/mobile/sms_login/",
  EMAIL_LOGIN: URL_PREFIX.WEB_AFF + "/email/code_login/",
  PWD_LOGIN: URL_PREFIX.WEB_AFF + "/user/login/",
  OAUTH_LOGIN_CALL: URL_PREFIX.WEB_AFF + "/oauth/login/call/",
  OAUTH_LOGIN_ONLY: URL_PREFIX.WEB_AFF + "/oauth/login_only/",
  OAUTH_LOGIN: URL_PREFIX.WEB_AFF + "/oauth/login/",
  SUBJECT_LOGIN_LIST: URL_PREFIX.WEB_AFF + "/subject/login_list/",
  SUBJECT_LOGIN: URL_PREFIX.WEB_AFF + "/subject/login/",
  LOGOUT: URL_PREFIX.WEB_AFF + "/logout/",
  // register
  REGISTER_EMAIL_USER_ONLY: URL_PREFIX.WEB_AFF + "/email/register/only_user/",
  REGISTER_EMAIL: URL_PREFIX.WEB_AFF + "/email/register/",
  REGISTER_MOBILE_USER_ONLY: URL_PREFIX.WEB_AFF + "/mobile/register/only_user/",
  REGISTER_MOBILE: URL_PREFIX.WEB_AFF + "/mobile/register/",
  // forget password
  RESET_BY_MOBILE: URL_PREFIX.WEB_AFF + "/mobile/password/reset/",
  RESET_BY_EMAIL: URL_PREFIX.WEB_AFF + "/email/password/reset/",
  // invite
  MOBILE_INVITE: URL_PREFIX.WEB_AFF + "/invitation/mobile/invite/",
  EMAIL_INVITE: URL_PREFIX.WEB_AFF + "/invitation/email/invite/",
  // LARK_INVITE: `${URL_PREFIX.WEB_AFF}/invitation/lark/invite/`,
  INVITE_LIST: URL_PREFIX.WEB_AFF + "/invitation/list/",
  CANCEL_INVITE: URL_PREFIX.WEB_AFF + "/invitation/cancel/",
  RESEND_INVITE: URL_PREFIX.WEB_AFF + "/invitation/resend/",
  UPDATE_INVITE: URL_PREFIX.WEB_AFF + "/invitation/update/",
  CHECK_INVITE_VALID: URL_PREFIX.WEB_AFF + "/invitation/check/",
  ACCEPT_INVITE: URL_PREFIX.WEB_AFF + "/invitation/accept/",
  // subject
  CREATE_BY_USERNAME: URL_PREFIX.WEB_AFF + "/subject/username/create/",
  CREATE_BY_MOBILE: URL_PREFIX.WEB_AFF + "/subject/mobile/create/",
  CREATE_BY_EMAIL: URL_PREFIX.WEB_AFF + "/subject/email/create/",
  SUBJECT_LIST: URL_PREFIX.WEB_AFF + "/subject/all/list/",
  SUBJECT_DEPUTY_LIST: URL_PREFIX.WEB_AFF + "/subject/deputy/list/",
  SUBJECT_IDENTITY_LIST: URL_PREFIX.WEB_AFF + "/subject/identity/list/",
  UPDATE_DEPUTY_INFO: URL_PREFIX.WEB_AFF + "/deputy/update/",
  FREEZE_DEPUTY: URL_PREFIX.WEB_AFF + "/deputy/freeze/",
  DELETE_DEPUTY: URL_PREFIX.WEB_AFF + "/deputy/delete/",
  UPDATE_SUBJECT_INFO: URL_PREFIX.WEB_AFF + "/subject/update/",
  FREEZE_SUBJECT: URL_PREFIX.WEB_AFF + "/subject/freeze/",
  // resource
  RESOURCE_LIST: URL_PREFIX.WEB_AFF + "/resource/list/",
  // role
  CREATE_ROLE: URL_PREFIX.WEB_AFF + "/role/create/",
  UPDATE_ROLE: URL_PREFIX.WEB_AFF + "/role/update/",
  BAN_ROLE: URL_PREFIX.WEB_AFF + "/role/ban/",
  ROLE_LIST: URL_PREFIX.WEB_AFF + "/role/list/",
  ROLE_INFO: URL_PREFIX.WEB_AFF + "/role/info/",
  // user
  CREATE_USER_WITH_ROLE: URL_PREFIX.WEB_AFF + "/user/create_with_role/",
  ADD_USER_ROLE: URL_PREFIX.WEB_AFF + "/user_role/add/",
  DELETE_USER_ROLE: URL_PREFIX.WEB_AFF + "/user_role/del/",
  USER_ROLE_LIST: URL_PREFIX.WEB_AFF + "/user_role/list/",
  ALL_USER_ROLE_LIST: URL_PREFIX.WEB_AFF + "/user_role/all/list/",
  USER_PERMISSIONS: URL_PREFIX.WEB_AFF + "/user/permissions/",
  // super
  SUCCESSOR_SEND_CODE: URL_PREFIX.WEB_AFF + "/admin/successor/send_code/",
  TRANSFER_MANAGER: URL_PREFIX.WEB_AFF + "/admin/transfer/",
  // switch
  MEMBER_SWITCH: URL_PREFIX.WEB_AFF + "/member/switch/"
};
var WEB_SSO = {
  // mobile_verify
  MOBILE_CODE_URL: '/send_activation_code/',
  MOBILE_CODE_URL_V2: '/send_activation_code/v2/',
  // email_verify
  EMAIL_ACTIVATE_URL: '/send_email_activate_link/',
  EMAIL_ACTIVATE_URL_V2: '/send_email_activate_link/v2/',
  EMAIL_ACTIVATE_CODE_URL: '/send_email_activate_code/',
  EMAIL_ACTIVATE_CODE_URL_V2: '/send_email_activate_code/v2/',
  // login_status
  CHECK_LOGIN: '/check_login/',
  // mobile_login
  MOBILE_CODE_LOGIN_URL: '/quick_login/',
  MOBILE_CODE_LOGIN_URL_V2: '/quick_login/v2/',
  MOBILE_CODE_LOGIN_ONLY_URL: '/quick_login_only/',
  // password_login
  ACCOUNT_LOGIN_URL: '/account_login/',
  ACCOUNT_LOGIN_URL_V2: '/account_login/v2/',
  ACCOUNT_LOGIN_URL_V3: '/account_login/v3/',
  // auth_login
  AUTH_LOGIN_URL: '/passport/auth/wap_login/',
  BIND_WITH_MOBILE_LOGIN: '/bind_with_mobile_login/',
  AUTH_LOGIN: '/auth/login/',
  AUTH_LOGIN_ONLY: '/auth/login_only/',
  // logout
  LOGOUT: '/logout/',
  // email_login
  EMAIL_ACTIVATE_CODE_LOGIN: '/activate_email/code_login/',
  EMAIL_REGISTER: '/activate_email/register/',
  EMAIL_REGISTER_V2: '/activate_email/register/v2/',
  // mobile code register and login
  MOBILE_REGISTER_WITH_EMAIL: '/register/',
  MOBILE_REGISTER_WITH_EMAIL_V2: '/register/v2/',
  // password
  // get email code
  SSO_EMAIL_ACTIVATE_CODE_URL: '/sso/send_email_activate_code/',
  RESET_PASSWORD: '/reset_password/',
  RESET_PASSWORD_BY_EMAIL: '/activate_email/reset_password/',
  // bind_mobile
  BIND_MOBILE: '/bind_mobile/',
  // change_mobile
  CHANGE_MOBILE: '/change_mobile/',
  // quick_auth
  QUICK_AUTH: '/quick_auth/',
  // qrcode_login
  GET_QRCODE: '/get_qrcode/',
  CHECK_QRCONNECT: '/check_qrconnect/',
  SCAN_QRCODE: '/scan_qrcode/',
  CONFIRM_QRCODE: '/confirm_qrcode/',
  // register
  MOBILE_EMAIL_REGISTER: '/mobile_email_register/',
  // set password
  SET_PASWORD: '/password/set/'
};
var APP_URL = {
  SEND_MOBILE_CODE: URL_PREFIX.APP + "/send_code/",
  CHECK_MOBILE_CODE: URL_PREFIX.APP + "/check_code/",
  UNBIND_UNUSABLE_MOBILE: URL_PREFIX.APP + "/unbind_limited_unusable_mobile/",
  // login
  BIND_WITH_MOBILE_LOGIN: '/passport/auth/bind_with_mobile_login/',
  AUTH_LOGIN: '/passport/auth/login/',
  // user
  OAUTH_PROFILE: '/user/get/oauth_profile/'
};
var AUTH_URL = {
  WEB_SDK_INIT: URL_PREFIX.AUTH + "/common/v1/web_sdk_init/"
};
var SSO_AFF_URL = {
  MEMBER_SWITCH: URL_PREFIX.SSO_AFF + "/member/switch/"
};
var MOBILE_AFF_URL = {
  MEMBER_SWITCH: URL_PREFIX.MOBILE_AFF + "/member/switch/"
};
var COMMON_URL = {
  BIND_VERIFY_INFO: URL_PREFIX.COMMON + "/register/web/bind_verify_info/"
};

function loadScript(url, callback) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'complete' || script.readyState === 'loaded') {
        script.onreadystatechange = null;
        callback && callback();
      }
    };
  } else {
    script.onload = function () {
      callback && callback();
    };
  }
}
function getEnablePathList() {
  return [].concat(Object.values(WEB_URL), Object.values(WEB_AFF_URL), Object.values(WEB_SSO));
}
function getUrlRewriteRules() {
  var rewriteRuleList = Object.values(WEB_SSO).map(function (item) {
    return [item, '/passport/sso' + item];
  });
  return rewriteRuleList || [];
}
function setAcrawlerConfig(options) {
  var byted_acrawler = window.byted_acrawler;
  var enablePathList = getEnablePathList();
  var urlRewriteRules = getUrlRewriteRules();
  if (byted_acrawler) {
    byted_acrawler.init({
      sdi: options.sdi,
      aid: options.aid,
      // isSDK 为 true 并不会初始化，只会追加配置
      isSDK: true,
      // dfp: options.acrawler === 'cn' ? true : false,
      boe: options.isBoe || false,
      // intercept: true,
      enablePathList: enablePathList,
      urlRewriteRules: urlRewriteRules
    });
  }
}
function initAcrawler(region, options) {
  var url = 'https://sf16-secsdk.ibytedtos.com/obj/rc-web-sdk-gcs/webmssdk/1.0.0.303/webmssdk.js';
  if (region === 'gcp' || region === 'giso') {
    url = 'https://sf16-secsdk.ibytedtos.com/obj/rc-web-sdk-giso/webmssdk.js';
  } else if (region === 'sg') {
    url = 'https://sf16-secsdk.ibytedtos.com/obj/rc-web-sdk-sg/webmssdk/1.0.0.303/webmssdk.js';
  } else if (region === 'va' || region === 'gcs') {
    url = 'https://sf16-secsdk.ibytedtos.com/obj/rc-web-sdk-gcs/webmssdk/1.0.0.303/webmssdk.js';
  }
  if (options.acrawlerUrl) {
    url = options.acrawlerUrl;
  }
  if (window.byted_acrawler) {
    setAcrawlerConfig(options);
  } else {
    // Notice: 风控预期是让业务方自行引入 mssdk ，我们只新增 /passport 路径收集的配置项，不能帮业务引入并初始化。
    // 原因是合规问题——仅能让业务自行决定要不要采集信息，对接人 @张鸿博 @段湛洋
    loadScript(url, function () {
      setAcrawlerConfig(options);
    });
  }
}

function getCookie(key) {
  var arr,
    reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)');
  if (arr = document.cookie.match(reg)) {
    return unescape(arr[2]);
  }
  return '';
}
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}
function printGroupLog(title, content, style) {
  if (style === void 0) {
    style = true;
  }
  console.group(title);
  content && Object.keys(content).forEach(function (key) {
    style ? console.log(key, style || 'background: #222; color: #bada55', content[key]) : console.log(key, content[key]);
  });
  console.groupEnd();
}
function decodeString(str) {
  if (typeof str !== 'string') {
    return str;
  }
  var result = str;
  while (decodeURIComponent(result) !== result) {
    result = decodeURIComponent(result);
  }
  return result;
}
function objectToString(params) {
  return Object.keys(params).map(function (key) {
    var decodedKey = decodeString(key);
    var decodedValue = decodeString(params[key]);
    if (typeof decodedValue === 'object') {
      return encodeURIComponent(decodedKey) + "=" + encodeURIComponent(JSON.stringify(decodedValue));
    } else {
      return encodeURIComponent(decodedKey) + "=" + encodeURIComponent(decodedValue);
    }
  }).join('&');
}
function stringToObject(data) {
  if (!data) {
    return {};
  }
  var result = {};
  data.split('&').forEach(function (item) {
    var _item$split = item.split('='),
      itemKey = _item$split[0],
      itemValue = _item$split[1];
    result[itemKey] = itemValue;
  });
  return result;
}
/**
 * @param {string} str
 */
var writeUTF = function writeUTF(str) {
  var value = str.toString();
  var back = [];
  var code;
  for (var i = 0; i < value.length; i++) {
    code = value.charCodeAt(i);
    if (0x00 <= code && code <= 0x7f) {
      back.push(code);
    } else if (0x80 <= code && code <= 0x7ff) {
      back.push(192 | 31 & code >> 6);
      back.push(128 | 63 & code);
    } else if (0x800 <= code && code <= 0xd7ff || 0xe000 <= code && code <= 0xffff) {
      back.push(224 | 15 & code >> 12);
      back.push(128 | 63 & code >> 6);
      back.push(128 | 63 & code);
    }
  }
  for (var j = 0; j < back.length; j++) {
    back[j] &= 0xff;
  }
  return back;
};
var encrypt = function encrypt(value) {
  var result = [];
  var newCode = [];
  if (value === void 0) {
    return '';
  }
  newCode = writeUTF(value);
  for (var i = 0, length = newCode.length; i < length; ++i) {
    result.push((newCode[i] ^ 5).toString(16));
  }
  return result.join('');
};
/**
 * @param {object} params - what need to be encrypted
 * @param {string[]} keyList - the field to be encrypted
 */
var encryptParams = function encryptParams(params, keyList) {
  var value;
  var mix_mode = 0;
  var fixed_mix_mode = 0;
  if (typeof params !== 'object') {
    return params;
  }
  if (!keyList || keyList.length <= 0) {
    return params;
  }
  var newParams = _extends({
    mix_mode: mix_mode
  }, params);
  for (var i = 0, length = keyList.length; i < length; ++i) {
    value = newParams[keyList[i]];
    if (value !== void 0) {
      mix_mode |= 1;
      fixed_mix_mode |= 1;
      newParams[keyList[i]] = encrypt(value);
    }
  }
  newParams.mix_mode = mix_mode;
  newParams.fixed_mix_mode = fixed_mix_mode;
  return newParams;
};
var sortObjectToString = function sortObjectToString(params, length) {
  if (params === void 0) {
    params = {};
  }
  if (length === void 0) {
    length = -1;
  }
  var sortedArr = Object.keys(params).sort() || [];
  if (length >= 0) {
    sortedArr.splice(length);
  }
  var str = sortedArr.map(function (key) {
    var value = params[key];
    if (typeof value === 'object') {
      return key + "=" + JSON.stringify(value);
    } else {
      return key + "=" + value;
    }
  }).join('&');
  return {
    str: str,
    arr: sortedArr
  };
};
var signature = function signature(params, data, key) {
  if (params === void 0) {
    params = {};
  }
  if (data === void 0) {
    data = {};
  }
  if (key === void 0) {
    key = '';
  }
  if (!key) {
    return {};
  }
  var _sortObjectToString = sortObjectToString(params, 10),
    _sortObjectToString$s = _sortObjectToString.str,
    str1 = _sortObjectToString$s === void 0 ? '' : _sortObjectToString$s,
    _sortObjectToString$a = _sortObjectToString.arr,
    arr1 = _sortObjectToString$a === void 0 ? [] : _sortObjectToString$a;
  var _sortObjectToString2 = sortObjectToString(data),
    _sortObjectToString2$ = _sortObjectToString2.str,
    str2 = _sortObjectToString2$ === void 0 ? '' : _sortObjectToString2$;
  var stringSignTemp = str1 + "&" + str2 + "&app_key=" + key;
  var digest = sha256(stringSignTemp);
  var sign = hex.stringify(digest);
  var qs = encrypt(arr1.join(','));
  return {
    sign: sign,
    qs: qs
  };
};

var _excluded = ["request"];
var repeatRequest, fp;
var defaultOptions = {
  commonOptions: {
    aid: 0,
    iid: '0',
    did: '0'
  },
  captchaOptions: {
    sideSlide: 'disabled',
    lang: 'zh',
    showMode: 'mask',
    region: 'sg',
    app_name: ''
  }
};
var captchaMap = {
  // cn: CNCaptcha,
  sg: SGCaptcha,
  va: VACaptcha,
  gcp: INCaptcha,
  "in": INCaptcha,
  ttp: TTPCaptcha
};
var TTGCaptcha;
var initCaptcha = function initCaptcha(props) {
  var _props$captchaOptions = props.captchaOptions,
    captchaOptions = _props$captchaOptions === void 0 ? {} : _props$captchaOptions,
    secondVerifyWebOptions = props.secondVerifyWebOptions,
    getDynamicCaptchaConfig = props.getDynamicCaptchaConfig;
  var options = {
    commonOptions: _extends({}, defaultOptions.commonOptions, {
      aid: props.aid,
      did: props.did ? String(props.did) : '0',
      iid: props.iid ? String(props.iid) : '0'
    }),
    captchaOptions: _extends({}, defaultOptions.captchaOptions, {
      sideSlide: props.captchaSideSlide || 'disabled',
      lang: props.language || 'zh',
      showMode: props.captchaShowMode || 'mask',
      region: props.region || 'sg',
      app_name: props.appName || '',
      host: props.captchaHost || ''
    }, captchaOptions),
    secondVerifyWebOptions: secondVerifyWebOptions
  };
  TTGCaptcha = captchaMap[props.region || 'sg'] || SGCaptcha;
  // for show use dynamic host
  if (getDynamicCaptchaConfig) {
    TTGCaptcha.getDynamicCaptchaConfig = getDynamicCaptchaConfig;
  }
  // umd only has .default
  // https://github.com/rollup/rollup/issues/1156
  if (!TTGCaptcha.init) {
    var _TTGCaptcha;
    TTGCaptcha = (_TTGCaptcha = TTGCaptcha) === null || _TTGCaptcha === void 0 ? void 0 : _TTGCaptcha["default"];
  }
  if (props.captchaConfig && typeof TTGCaptcha.config === 'function') {
    TTGCaptcha.config(props.captchaConfig);
  }
  TTGCaptcha.init(options, function () {}, function () {});
};
var sliderView = {
  init: function init(params) {
    var request = params.request,
      props = _objectWithoutPropertiesLoose(params, _excluded);
    repeatRequest = request;
    initCaptcha(props);
  },
  show: function show(config) {
    var requestConfig = config.requestConfig,
      verifyData = config.verifyData,
      requestData = config.requestData;
    var parsedVerifyData = {};
    try {
      parsedVerifyData = JSON.parse(verifyData);
    } catch (e) {
      console.log('wrong desision config!');
    }
    var host = undefined;
    if (TTGCaptcha.getDynamicCaptchaConfig) {
      var _requestConfig$url, _requestConfig$url$ma;
      var urlHost = (_requestConfig$url = requestConfig.url) === null || _requestConfig$url === void 0 ? void 0 : (_requestConfig$url$ma = _requestConfig$url.match(/^https?:\/\/(.*?)\//)) === null || _requestConfig$url$ma === void 0 ? void 0 : _requestConfig$url$ma[0];
      host = TTGCaptcha.getDynamicCaptchaConfig(urlHost || requestConfig.baseURL);
    }
    var requestDataStr = requestConfig.data || '';
    // rewrite request data
    if (requestData) {
      var originRequestData = stringToObject(requestDataStr);
      requestDataStr = objectToString(_extends({}, originRequestData, requestData));
    }
    return new Promise(function (resolve, reject) {
      TTGCaptcha.render({
        verify_data: parsedVerifyData,
        captchaOptions: {
          host: host,
          successCb: function () {
            try {
              sliderView.hasShowed = false;
              return Promise.resolve(TTGCaptcha.getFp()).then(function (fp) {
                var _repeatRequest;
                (_repeatRequest = repeatRequest) === null || _repeatRequest === void 0 ? void 0 : _repeatRequest(_extends({}, requestConfig, {
                  params: _extends({}, requestConfig.params, {
                    fp: fp,
                    isResend: true
                  }),
                  data: requestDataStr
                })).then(function (data) {
                  resolve(data);
                })["catch"](function (err) {
                  reject(err);
                });
              });
            } catch (e) {
              return Promise.reject(e);
            }
          },
          closeCb: function closeCb() {
            reject('CLOSE_CAPTCHA');
          }
        },
        secondVerifyWebOptions: {
          callBack: function (res) {
            try {
              var _repeatRequest2;
              (_repeatRequest2 = repeatRequest) === null || _repeatRequest2 === void 0 ? void 0 : _repeatRequest2(_extends({}, requestConfig, {
                params: _extends({}, requestConfig.params, {
                  isResend: true
                }),
                data: requestDataStr
              })).then(function (data) {
                resolve(data);
              })["catch"](function (err) {
                reject(err);
              });
              return Promise.resolve();
            } catch (e) {
              return Promise.reject(e);
            }
          },
          closeCallBack: function closeCallBack() {
            reject({
              description: 'SECOND_VALID',
              requestData: requestData
            });
          }
        }
      });
    });
  },
  getFp: function getFp() {
    // 如果已经存在fp，则走缓存
    if (fp) {
      return Promise.resolve(fp);
    }
    var defaultFp = function defaultFp() {
      return new Promise(function (resolve) {
        setTimeout(function () {
          return resolve('');
        }, 1000);
      });
    };
    return Promise.race([defaultFp(), TTGCaptcha.getFp()]).then(function (fpStr) {
      fp = fpStr;
      console.log('===>', fpStr);
      return fpStr;
    });
  }
};

var data = {};
function set(key, value) {
  return new Promise(function (resolve) {
    data[key] = value;
    resolve(data);
  });
}
function get(key) {
  return data[key];
}

var _excluded$1 = ["request"];
var SUSPICIOUS_LOGIN_ERROR_CODE_TO_METHOD = {
  2020: 'PASSWORD',
  2032: 'SMS',
  2033: 'EMAIL'
};
var requestInstance;
/**
 * init:
 *  init sdk. lang params or something like these
 * call:
 * 1. call the method
 * 2. if success then retry the request
 * 2.1 rewrite the params and data when you are gonna retry the request
 * 2.2 if the request failed, then throw errors again
 * 3. if the user choose to cancel, then reject directly
 */
var verificationView = {
  init: function init(options) {
    var request = options.request,
      props = _objectWithoutPropertiesLoose(options, _excluded$1);
    requestInstance = request;
    verification.init({
      lang: options.pageLang || 'en',
      starlingZoneHost: options.starlingZoneHost,
      request: request,
      hooks: props.hooks
    });
  },
  call: function call(options) {
    var method = options.method,
      verifyTicket = options.verifyTicket,
      _options$commonParams = options.commonParams,
      commonParams = _options$commonParams === void 0 ? {} : _options$commonParams,
      requestInfo = options.requestInfo;
    // 1. patch request data
    var requestDataStr = requestInfo.requestConfig.data || '';
    if (requestInfo.patchRequestData) {
      var originRequestData = stringToObject(requestDataStr);
      requestDataStr = objectToString(_extends({}, originRequestData, requestInfo.patchRequestData));
    }
    // 2. retry when success
    return verification.call({
      method: method,
      params: _extends({
        verify_ticket: verifyTicket
      }, commonParams)
    }).then(function () {
      var _requestInstance;
      return (_requestInstance = requestInstance) === null || _requestInstance === void 0 ? void 0 : _requestInstance(_extends({}, requestInfo.requestConfig, {
        params: _extends({}, requestInfo.requestConfig.params, {
          isResend: true,
          verify_ticket: verifyTicket
        }),
        data: requestDataStr
      }));
    });
  }
};
function dispatchVerification(options) {
  var _resp$data, _resp$data2, _resp$data3, _resp$data4;
  var resp = options.resp,
    config = options.config;
  var errorCode = (resp === null || resp === void 0 ? void 0 : (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.error_code) || (resp === null || resp === void 0 ? void 0 : resp.error_code);
  var method = SUSPICIOUS_LOGIN_ERROR_CODE_TO_METHOD[errorCode];
  var profileKey = (resp === null || resp === void 0 ? void 0 : (_resp$data2 = resp.data) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.profile_key) || (resp === null || resp === void 0 ? void 0 : resp.profile_key);
  var verifyTicket = (resp === null || resp === void 0 ? void 0 : (_resp$data3 = resp.data) === null || _resp$data3 === void 0 ? void 0 : _resp$data3.verify_ticket) || (resp === null || resp === void 0 ? void 0 : resp.verify_ticket);
  var smsCodeKey = (resp === null || resp === void 0 ? void 0 : (_resp$data4 = resp.data) === null || _resp$data4 === void 0 ? void 0 : _resp$data4.sms_code_key) || (resp === null || resp === void 0 ? void 0 : resp.sms_code_key);
  return verificationView.call({
    method: method,
    verifyTicket: verifyTicket,
    requestInfo: {
      requestConfig: config,
      patchRequestData: {
        profile_key: profileKey,
        verify_ticket: verifyTicket,
        sms_code_key: smsCodeKey
      }
    }
  });
}

var _excluded$2 = ["isResend"];
// initResponseAdapt
var handlerMap = {
  web: {},
  sso: {
    respHandler: function respHandler(res) {
      return (res === null || res === void 0 ? void 0 : res.error_code) === 0;
    },
    successCallBack: function successCallBack(res) {
      // sso interface { error_code: 0, description: '', mobile_ticket: '' }
      // but some sso interface { data: { ... }, message: 'success', error_code: 0 }
      if ((res === null || res === void 0 ? void 0 : res.message) === 'success') {
        return res.data;
      }
      return res;
    },
    failCallBack: function failCallBack(res) {
      return res;
    }
  },
  app: {},
  auth: {
    respHandler: function respHandler(res) {
      console.log('====== auth ======');
      return (res === null || res === void 0 ? void 0 : res.status_code) === 0;
    },
    successCallBack: function successCallBack(res) {
      console.log(res);
      console.log('====== auth ======');
      return res.data;
    },
    failCallBack: function failCallBack(res) {
      return res;
    }
  }
};
var after = function after(res, xhr, cacheRedirectDomain) {
  var _res$config, _res$headers, _res$headers2, _resp, _resp$data, _resp2, _resp3, _resp3$data, _resp4, _resp4$data, _resp5, _resp6, _initProps$secondVeri;
  // get sdk type
  var account_sdk_source = res.config.params.account_sdk_source;
  // get sdk response adaptor
  var handler = handlerMap[account_sdk_source];
  // determine whether the request is successful
  var respHandler = (handler === null || handler === void 0 ? void 0 : handler.respHandler) || function (resp) {
    return (resp === null || resp === void 0 ? void 0 : resp.message) === 'success';
  };
  // format success response
  var successCallBack = (handler === null || handler === void 0 ? void 0 : handler.successCallBack) || function (resp) {
    return resp === null || resp === void 0 ? void 0 : resp.data;
  };
  // format fail response
  var failCallBack = (handler === null || handler === void 0 ? void 0 : handler.failCallBack) || function (resp) {
    return resp === null || resp === void 0 ? void 0 : resp.data;
  };
  var url = (res === null || res === void 0 ? void 0 : (_res$config = res.config) === null || _res$config === void 0 ? void 0 : _res$config.url) || '';
  var logid = (res === null || res === void 0 ? void 0 : (_res$headers = res.headers) === null || _res$headers === void 0 ? void 0 : _res$headers['x-tt-logid']) || '';
  var idvDecisionConf = (res === null || res === void 0 ? void 0 : (_res$headers2 = res.headers) === null || _res$headers2 === void 0 ? void 0 : _res$headers2['x-tt-verify-idv-decision-conf']) || '';
  var resp = (res === null || res === void 0 ? void 0 : res.data) || {};
  var initProps = get('initProps');
  var printLog = (initProps === null || initProps === void 0 ? void 0 : initProps.printLog) || false;
  if (typeof resp === 'string') {
    try {
      resp = JSON.parse(resp);
    } catch (error) {
      console.log(error);
    }
  }
  // success
  // if (resp && (resp.message === 'success' || resp.error_code === 0)) {
  if (respHandler(resp)) {
    if (printLog) {
      printGroupLog("call " + url + " result >>>>", {
        '%cSUCCESS': successCallBack(resp),
        '%cLogid': logid
      });
    }
    return Promise.resolve(successCallBack(resp));
  }
  // fail
  if (printLog) {
    printGroupLog("call " + url + " result >>>>", {
      '%cERROR': failCallBack(resp),
      '%cLogid': logid
    });
  }
  var errorCode = ((_resp = resp) === null || _resp === void 0 ? void 0 : (_resp$data = _resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.error_code) || ((_resp2 = resp) === null || _resp2 === void 0 ? void 0 : _resp2.error_code);
  // 302.307 https://bytedance.feishu.cn/docx/doxcnkszzfr8YfPjISFRtLUsyYe?useNewLarklet=1
  if (errorCode === 4017) {
    cacheRedirectDomain && cacheRedirectDomain(resp.data.domain);
    var requestDataStr = res.config.data || '';
    // rewrite request data
    var originRequestData = stringToObject(requestDataStr);
    var newRequestData = _extends({}, originRequestData, resp.data.new_params);
    return xhr(_extends({}, res.config, {
      baseURL: res.data.domain,
      data: newRequestData
    }));
  }
  // web verification
  if (Object.keys(SUSPICIOUS_LOGIN_ERROR_CODE_TO_METHOD).includes(errorCode + '')) {
    return dispatchVerification({
      resp: resp,
      config: res === null || res === void 0 ? void 0 : res.config
    })["catch"](function (e) {
      // cancel verify
      if (!e) {
        var formatResp = failCallBack(resp);
        return Promise.reject(_extends({}, formatResp, {
          log_id: logid,
          idv_decision_conf: idvDecisionConf
        }));
      } else {
        // repeat
        console.log(e);
        return Promise.reject(e);
      }
    });
  }
  // slider
  var sliderDecisionConfig = ((_resp3 = resp) === null || _resp3 === void 0 ? void 0 : (_resp3$data = _resp3.data) === null || _resp3$data === void 0 ? void 0 : _resp3$data.verify_center_decision_conf) || ((_resp4 = resp) === null || _resp4 === void 0 ? void 0 : (_resp4$data = _resp4.data) === null || _resp4$data === void 0 ? void 0 : _resp4$data.verify_center_secondary_decision_conf) || ((_resp5 = resp) === null || _resp5 === void 0 ? void 0 : _resp5.verify_center_decision_conf) || ((_resp6 = resp) === null || _resp6 === void 0 ? void 0 : _resp6.verify_center_secondary_decision_conf);
  // when error_code === 2046, allow users to deal with the verification themseleves
  if (errorCode === 2046 && typeof (initProps === null || initProps === void 0 ? void 0 : (_initProps$secondVeri = initProps.secondVerifyWebOptions) === null || _initProps$secondVeri === void 0 ? void 0 : _initProps$secondVeri.onValid) === 'function') {
    var _initProps$secondVeri2;
    initProps === null || initProps === void 0 ? void 0 : (_initProps$secondVeri2 = initProps.secondVerifyWebOptions) === null || _initProps$secondVeri2 === void 0 ? void 0 : _initProps$secondVeri2.onValid();
    return Promise.reject({
      description: 'SECOND_VALID'
    });
  }
  if (sliderDecisionConfig && !sliderView.hasShowed) {
    var _resp7, _resp7$data, _resp8, _resp9, _resp9$data, _resp10;
    sliderView.hasShowed = true;
    // when error_code === 2046 && sms_code_key, it's required to bring sms_code_key in data of the next request
    var smsCodeKey = ((_resp7 = resp) === null || _resp7 === void 0 ? void 0 : (_resp7$data = _resp7.data) === null || _resp7$data === void 0 ? void 0 : _resp7$data.sms_code_key) || ((_resp8 = resp) === null || _resp8 === void 0 ? void 0 : _resp8.sms_code_key);
    var profile_key = ((_resp9 = resp) === null || _resp9 === void 0 ? void 0 : (_resp9$data = _resp9.data) === null || _resp9$data === void 0 ? void 0 : _resp9$data.profile_key) || ((_resp10 = resp) === null || _resp10 === void 0 ? void 0 : _resp10.profile_key);
    var requestData = errorCode === 2046 && smsCodeKey ? {
      sms_code_key: smsCodeKey
    } : profile_key ? {
      profile_key: profile_key
    } : undefined; // when has third profile_key add it to data of the next request
    return Promise.resolve(sliderView.show({
      verifyData: sliderDecisionConfig,
      requestConfig: res === null || res === void 0 ? void 0 : res.config,
      requestData: requestData
    })).then(function (data) {
      sliderView.hasShowed = false;
      return Promise.resolve(data);
    })["catch"](function (err) {
      sliderView.hasShowed = false;
      return Promise.reject(err);
    });
  } else {
    var formatResp = failCallBack(resp);
    return Promise.reject(_extends({}, formatResp, {
      log_id: logid,
      idv_decision_conf: idvDecisionConf
    }));
  }
};
var before = function before(config, commonParams, getDynamicConfig) {
  if (commonParams === void 0) {
    commonParams = {};
  }
  try {
    var initProps = get('initProps');
    var printLog = (initProps === null || initProps === void 0 ? void 0 : initProps.printLog) || false;
    return Promise.resolve(sliderView.getFp()).then(function (verifyFp) {
      var _config$params2;
      var appKey = (initProps === null || initProps === void 0 ? void 0 : initProps.appKey) || '';
      // const { isResend = false, ...requestConfigParams } = config.params;
      var url = config === null || config === void 0 ? void 0 : config.url;
      var method = (config === null || config === void 0 ? void 0 : config.method) || 'get';
      var data = (config === null || config === void 0 ? void 0 : config.data) || {};
      var customBaseURL = '';
      var customHeaders = {};
      var customParams = {};
      if (getDynamicConfig) {
        var _getDynamicConfig = getDynamicConfig({
            url: url,
            data: data,
            params: commonParams
          }),
          baseURL = _getDynamicConfig.baseURL,
          _headers = _getDynamicConfig.headers,
          params = _getDynamicConfig.params;
        if (baseURL) {
          customBaseURL = baseURL;
        }
        if (params) {
          customParams = params;
        }
        customHeaders = _headers || {};
      } else {
        var _config$data, _config$params;
        var requestSource = (config === null || config === void 0 ? void 0 : (_config$data = config.data) === null || _config$data === void 0 ? void 0 : _config$data.passport_request_source) || (config === null || config === void 0 ? void 0 : (_config$params = config.params) === null || _config$params === void 0 ? void 0 : _config$params.passport_request_source);
        if (requestSource === 'tiktok_web_verify') {
          customBaseURL = "https://" + window.location.hostname;
        }
      }
      // csrf headers
      var csrfHeader = {
        'x-tt-passport-csrf-token': getCookie('passport_csrf_token') || getCookie('passport_csrf_token_default') || ''
      };
      var headers = Object.assign({
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json, text/javascript'
      }, config.headers || {}, csrfHeader, customHeaders
      // 'x-tt-passport-js-sdk-version': "2.1.3-tiktok",
      // 'x-tt-passport-use-js-sdk': 1,
      );

      config.headers = headers;
      if (customBaseURL) {
        config.baseURL = customBaseURL;
      }
      // log
      if (printLog) {
        printGroupLog(method + " " + url + " >>>>", {
          '%cdata >>>>': data,
          '%ccommon params >>>>': commonParams
        });
      }
      // whether the request is resent due to slider verification code
      if ((_config$params2 = config.params) !== null && _config$params2 !== void 0 && _config$params2.isResend) {
        var _config$params3 = config.params,
          isResend = _config$params3.isResend,
          realParams = _objectWithoutPropertiesLoose(_config$params3, _excluded$2);
        return _extends({}, config, {
          params: realParams
        });
        // return Promise.resolve(requestConfig);
      }
      // filter data, only get defined fields
      var filterData = {};
      Object.keys(data).filter(function (key) {
        return data[key] !== undefined;
      }).forEach(function (key) {
        filterData[key] = data[key];
      });
      // data transform
      if (['post', 'POST'].includes(method)) {
        var postParams = _extends({}, commonParams, {
          verifyFp: verifyFp
        }, customParams, (config === null || config === void 0 ? void 0 : config.params) || {});
        var signParams = signature(postParams, filterData, appKey);
        config.params = _extends({}, postParams, signParams);
        if (isFormData(data)) {
          config.data = data;
        } else {
          config.data = objectToString(filterData);
        }
      }
      if (['get', 'GET'].includes(method)) {
        var getParams = _extends({}, filterData, commonParams, {
          verifyFp: verifyFp
        }, customParams, config.params);
        var _signParams = signature(getParams, {}, appKey);
        config.params = _extends({}, getParams, _signParams);
      }
      return config;
      // return Promise.resolve(requestConfig);
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

function createXHR(commonParams, xhrConfig) {
  var initProps = get('initProps') || {};
  var _ref = xhrConfig !== null && xhrConfig !== void 0 ? xhrConfig : {},
    getDynamicConfig = _ref.getDynamicConfig,
    cacheRedirectDomain = _ref.cacheRedirectDomain;
  var host = initProps.host,
    isBoe = initProps.isBoe;
  var xhr = axios.create({
    withCredentials: true
  });
  var baseURL = host || window && (isBoe ? window.location.protocol : 'https:') + "//" + window.location.hostname;
  xhr.interceptors.request.use(function (config) {
    config.baseURL = baseURL;
    return before(config, commonParams, getDynamicConfig);
  }, undefined);
  xhr.interceptors.response.use(function (config) {
    return after(config, xhr, cacheRedirectDomain);
  }, undefined);
  return xhr;
}

function parseResponse(config) {
  var _config$data, _config$data$data;
  var resp = (config === null || config === void 0 ? void 0 : (_config$data = config.data) === null || _config$data === void 0 ? void 0 : (_config$data$data = _config$data.data) === null || _config$data$data === void 0 ? void 0 : _config$data$data.response) || (config === null || config === void 0 ? void 0 : config.data) || {};
  if (typeof resp === 'string') {
    try {
      resp = JSON.parse(resp);
    } catch (error) {
      console.log('fetch', error);
    }
  }
  return resp;
}
var after$1 = function after(res) {
  var _res$config, _res$headers, _res$headers2, _resp$data;
  var url = (res === null || res === void 0 ? void 0 : (_res$config = res.config) === null || _res$config === void 0 ? void 0 : _res$config.url) || '';
  var logid = (res === null || res === void 0 ? void 0 : (_res$headers = res.headers) === null || _res$headers === void 0 ? void 0 : _res$headers['x-tt-logid']) || '';
  var idvDecisionConf = (res === null || res === void 0 ? void 0 : (_res$headers2 = res.headers) === null || _res$headers2 === void 0 ? void 0 : _res$headers2['x-tt-verify-idv-decision-conf']) || '';
  var resp = parseResponse(res);
  var initProps = get('initProps');
  var printLog = (initProps === null || initProps === void 0 ? void 0 : initProps.printLog) || false;
  // success
  if ((resp === null || resp === void 0 ? void 0 : resp.message) === 'success') {
    if (printLog) {
      printGroupLog("call " + url + " result >>>>", {
        SUCCESS: resp.data,
        Logid: logid
      }, false);
    }
    return Promise.resolve(resp.data);
  }
  // fail
  if (printLog) {
    printGroupLog("call " + url + " result >>>>", {
      ERROR: resp.data,
      Logid: logid
    }, false);
  }
  // slider
  var ifShowCaptcha = !(initProps !== null && initProps !== void 0 && initProps.appShowCaptcha);
  var sliderDecisionConfig = resp === null || resp === void 0 ? void 0 : (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.verify_center_decision_conf;
  if (ifShowCaptcha && sliderDecisionConfig) {
    return Promise.resolve(sliderView.show({
      verifyData: sliderDecisionConfig,
      requestConfig: res === null || res === void 0 ? void 0 : res.config
    }));
  }
  return Promise.reject(_extends({}, resp.data, {
    log_id: logid,
    idv_decision_conf: idvDecisionConf
  }));
};

var adapterInit = function adapterInit() {
  return function (config) {
    var baseURL = config.baseURL,
      path = config.url,
      _config$method = config.method,
      method = _config$method === void 0 ? 'GET' : _config$method,
      _config$params = config.params,
      params = _config$params === void 0 ? {} : _config$params,
      _config$data = config.data,
      data = _config$data === void 0 ? {} : _config$data;
    var initProps = get('initProps');
    var fetch = initProps.fetch;
    var printLog = (initProps === null || initProps === void 0 ? void 0 : initProps.printLog) || false;
    var url = isUri.isValid(path) ? path : baseURL + path;
    // log
    if (printLog) {
      printGroupLog(method + " " + url + " >>>>", {
        'data >>>>': data,
        'params >>>>': params
      }, false);
    }
    var requestData = {
      url: url,
      method: method.toUpperCase(),
      params: _extends({}, params, {
        is_native_h5: 1
      }),
      data: data,
      needCommonParams: true,
      header: {
        'x-tt-passport-csrf-token': getCookie('passport_csrf_token') || getCookie('passport_csrf_token_default') || ''
      }
    };
    return fetch(requestData).then(function (data) {
      return {
        data: data,
        status: 200,
        statusText: 'ok',
        config: config
      };
    });
  };
};

function createFetch() {
  var initProps = get('initProps') || {};
  var host = initProps.host,
    _initProps$isBoe = initProps.isBoe,
    isBoe = _initProps$isBoe === void 0 ? false : _initProps$isBoe;
  var xhr = axios.create({
    baseURL: host || window && (isBoe ? 'http' : 'https') + "://" + window.location.hostname,
    adapter: adapterInit(),
    withCredentials: true,
    transformRequest: [function (data) {
      var dataObj = data;
      if (typeof data === 'string') {
        try {
          dataObj = JSON.parse(data);
        } catch (error) {
          console.log(error);
        }
      }
      return dataObj;
    }]
  });
  xhr.interceptors.response.use(after$1, undefined);
  return xhr;
}

var BaseInterface = function BaseInterface(props, type) {
  // if (printLog) {
  console.log('%cAccountApi Version >>>>%O', 'background: #222; color: #bada55', "2.1.3-tiktok");
  // }
  set('initProps', props);
  // init request
  this.request = new RequestBehavior(props, type);
  sliderView.init(_extends({}, props, {
    request: this.request
  }));
  // web verification
  verificationView.init(_extends({}, props, {
    request: this.request
  }));
}; // init Params
var initParams = function initParams(props, type) {
  var _props$scene = props.scene,
    scene = _props$scene === void 0 ? 'normal' : _props$scene,
    aid = props.aid,
    _props$language = props.language,
    language = _props$language === void 0 ? '' : _props$language,
    _props$subjectAid = props.subjectAid,
    subjectAid = _props$subjectAid === void 0 ? 0 : _props$subjectAid,
    _props$aff_multi_logi = props.aff_multi_login,
    aff_multi_login = _props$aff_multi_logi === void 0 ? 0 : _props$aff_multi_logi,
    _props$generalParams = props.generalParams,
    generalParams = _props$generalParams === void 0 ? {} : _props$generalParams;
  var params;
  // Handling common parameters in fetch -- web
  if (type === 'web') {
    var commonParams = {
      aid: aid
    };
    if (scene === 'aff') {
      commonParams.subject_aid = subjectAid;
    }
    if (aff_multi_login === 1) {
      commonParams.aff_multi_login = 1;
    }
    params = commonParams;
  }
  if (type === 'sso' || type === 'auth') {
    var _commonParams = {
      aid: aid
    };
    if (aff_multi_login === 1) {
      _commonParams.aff_multi_login = 1;
    }
    params = _commonParams;
  }
  params = _extends({}, params, {
    account_sdk_source: type,
    sdk_version: "2.1.3-tiktok"
  });
  if (generalParams) {
    try {
      params = _extends({}, generalParams, params);
    } catch (error) {
      console.error('[error], generalParams is not object!');
    }
  }
  // language
  if (language) {
    params = _extends({}, params, {
      language: language
    });
  }
  return params;
};
//  class request
var RequestBehavior = function RequestBehavior(props, type) {
  var _get;
  if (type === void 0) {
    type = 'web';
  }
  if ((_get = get('initProps')) !== null && _get !== void 0 && _get.fetch) {
    return createFetch();
  } else {
    return createXHR(initParams(props, type), props.xhrConfig);
  }
};

var LoginAPI = function LoginAPI(props) {
  var _this = this;
  /**
   * @param {string} mobile - the mobile used to login
   * @return {Promise} send result
   */
  this.sendCode = function (params) {
    var mobile = params.mobile,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: 7
    }, extra_params), ['mobile', 'type']);
    return _this.request({
      url: WEB_AFF_URL.SEND_MOBILE_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} mobile - the mobile used to login
   * @param {string} code - the captcha
   * @param {number} need_frozen_user - whether return users in frozen
   * @return {Promise} login result
   */
  this.smsLogin = function (params) {
    var mobile = params.mobile,
      code = params.code,
      _params$need_frozen_u = params.need_frozen_user,
      need_frozen_user = _params$need_frozen_u === void 0 ? 0 : _params$need_frozen_u,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      need_frozen_user: need_frozen_user,
      type: 7
    }, extra_params), ['mobile', 'type', 'code']);
    return _this.request({
      url: WEB_AFF_URL.SMS_LOGIN,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - the email used to login
   * @return {Promise} send result
   */
  this.sendEmailCode = function (params) {
    var email = params.email,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      email: email,
      type: 13
    }, extra_params), ['email', 'type']);
    return _this.request({
      url: WEB_AFF_URL.SEND_EMAIL_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - the email used to login
   * @param {string} code - the captcha
   * @param {number} need_frozen_user - whether return users in frozen
   * @return {Promise} login result
   */
  this.emailLogin = function (params) {
    var email = params.email,
      code = params.code,
      _params$need_frozen_u2 = params.need_frozen_user,
      need_frozen_user = _params$need_frozen_u2 === void 0 ? 0 : _params$need_frozen_u2,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      need_frozen_user: need_frozen_user,
      type: 13
    }, extra_params), ['email', 'type', 'code']);
    return _this.request({
      url: WEB_AFF_URL.EMAIL_LOGIN,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - the email used to login
   * @param {string} username - the username used to login
   * @param {string} mobile - the mobile used to login
   * @param {string} account - the account used to login, whose value shoule be email or username or mobile
   * @param {string} password - corresponding password
   * @param {number} need_frozen_user - whether return users in frozen
   * @return {Promise} login result
   */
  this.pwdLogin = function (params) {
    var _extends2;
    var password = params.password,
      _params$need_frozen_u3 = params.need_frozen_user,
      need_frozen_user = _params$need_frozen_u3 === void 0 ? 0 : _params$need_frozen_u3,
      _params$extra_params5 = params.extra_params,
      extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var loginType = ['email', 'username', 'mobile', 'account'].find(function (item) {
      return !!params[item];
    });
    if (!loginType) {
      return Promise.reject();
    }
    var data = encryptParams(_extends((_extends2 = {
      password: password
    }, _extends2[loginType] = params[loginType], _extends2.need_frozen_user = need_frozen_user, _extends2), extra_params), ['password', loginType]);
    return _this.request({
      url: WEB_AFF_URL.PWD_LOGIN,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {number} platform_app_id - the app id of the third party used to login
   * @param {string} next - encoded redirect url after successful authorization
   * @return {Promise} authorize result
   */
  this.oauthLoginCall = function (params) {
    var platform_app_id = params.platform_app_id,
      next = params.next,
      _params$extra_params6 = params.extra_params,
      extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    var _ref = get('initProps') || {},
      aid = _ref.aid,
      subjectAid = _ref.subjectAid;
    var queryStr = objectToString(_extends({
      platform_app_id: platform_app_id,
      next: next,
      aid: aid,
      subject_aid: subjectAid,
      account_sdk_source: 'web'
    }, extra_params));
    window.location.href = WEB_AFF_URL.OAUTH_LOGIN_CALL + "?" + queryStr;
    // return new Promise((resolve, reject) => {
    //   this.request({
    //     url: WEB_AFF_URL.OAUTH_LOGIN_CALL,
    //     method: 'GET',
    //     data: {
    //       platform_app_id,
    //       next,
    //     },
    //   })
    //     .then((data: any) => {
    //       resolve(data);
    //     })
    //     .catch((e: any) => {
    //       reject(e);
    //     });
    // });
  };
  /**
   * @param {string} platform_app_id - the app id of the third party used to login
   * @param {string} redirect_uri - parameter 'oauth_redirect_uri' in the url query after calling oauthLoginCall successfully
   * @param {string} code - parameter 'oauth_code' in the url query after calling oauthLoginCall successfully
   * @param {number} need_frozen_user - whether return users in frozen
   * @param {string} login_only - 'true' for only login, 'false' for register and login
   * @return {Promise} login result
   */
  this.oauthLogin = function (params) {
    var platform_app_id = params.platform_app_id,
      redirect_uri = params.redirect_uri,
      code = params.code,
      _params$need_frozen_u4 = params.need_frozen_user,
      need_frozen_user = _params$need_frozen_u4 === void 0 ? 0 : _params$need_frozen_u4,
      _params$login_only = params.login_only,
      login_only = _params$login_only === void 0 ? true : _params$login_only,
      _params$extra_params7 = params.extra_params,
      extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    return _this.request({
      url: login_only ? WEB_AFF_URL.OAUTH_LOGIN_ONLY : WEB_AFF_URL.OAUTH_LOGIN,
      method: 'POST',
      data: _extends({
        platform_app_id: platform_app_id,
        redirect_uri: redirect_uri,
        code: code,
        need_frozen_user: need_frozen_user
      }, extra_params)
    });
  };
  /**
   * @return {Promise} list of companies the user can login
   */
  this.subjectLoginList = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params = params,
      _params$extra_params8 = _params.extra_params,
      extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    return _this.request({
      url: WEB_AFF_URL.SUBJECT_LOGIN_LIST,
      method: 'GET',
      data: extra_params
    });
  };
  /**
   * @param {string} login_subject_uid - the id of the subject user want to login
   * @param {string} user_identity_id - the id of the user who wants to login
   * @return {Promise} login result
   */
  this.subjectLogin = function (params) {
    var login_subject_uid = params.login_subject_uid,
      _params$user_identity = params.user_identity_id,
      user_identity_id = _params$user_identity === void 0 ? '0' : _params$user_identity,
      _params$extra_params9 = params.extra_params,
      extra_params = _params$extra_params9 === void 0 ? {} : _params$extra_params9;
    var data = encryptParams(_extends({
      login_subject_uid: login_subject_uid,
      user_identity_id: user_identity_id
    }, extra_params), ['login_subject_uid', 'user_identity_id']);
    return _this.request({
      url: WEB_AFF_URL.SUBJECT_LOGIN,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} next - the redirect url after logout successfully
   * @return {Promise} logout result
   */
  this.logout = function (params) {
    var _params$next = params.next,
      next = _params$next === void 0 ? '' : _params$next,
      _params$not_redirect = params.not_redirect,
      not_redirect = _params$not_redirect === void 0 ? false : _params$not_redirect;
    var _ref2 = get('initProps') || {},
      aid = _ref2.aid,
      subjectAid = _ref2.subjectAid;
    var data = {
      account_sdk_source: 'web',
      aid: aid,
      subject_aid: subjectAid,
      next: next
    };
    if (not_redirect) {
      return _this.request({
        url: WEB_AFF_URL.LOGOUT,
        method: 'GET',
        data: _extends({}, data, {
          next: encodeURIComponent(data.next)
        })
      });
    }
    window.location.href = WEB_AFF_URL.LOGOUT + "?" + objectToString(data);
  };
  /**
   * [Industry account user switching web]
   * @param {string} Industry account system userIdentityId
   */
  this.memberSwitch = function (params) {
    var to_sec_member_id = params.to_sec_member_id,
      _params$extra_params10 = params.extra_params,
      extra_params = _params$extra_params10 === void 0 ? {} : _params$extra_params10;
    return _this.request({
      url: WEB_AFF_URL.MEMBER_SWITCH,
      method: 'POST',
      data: _extends({
        to_sec_member_id: to_sec_member_id
      }, extra_params)
    });
  };
  var request = props.request;
  this.request = request;
};

var _excluded$3 = ["extra_params", "only_user"],
  _excluded2 = ["extra_params", "only_user"];
var RegisterAPI = function RegisterAPI(props) {
  var _this = this;
  /**
   * @param {string} email - the email used to register
   * @return {Promise} send result
   */
  this.sendEmailCode = function (params) {
    var email = params.email,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      email: email,
      type: 1
    }, extra_params), ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email to be verified
   * @param {string} code - the email captcha
   * @return {Promise} verify result
   */
  this.verifyEmail = function (params) {
    var email = params.email,
      code = params.code,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      type: 1
    }, extra_params), ['email', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CHECK_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} ticket - the ticket gained from verification
   * @param {string} base_infos
   * @param {string} subject_name
   * @param {string} password
   * @param {string} identity_card
   * @param {string} real_name
   * @param {string} only_user - whether register user account only
   * @return {Promise} register result
   */
  this.registerByEmail = function (params) {
    var _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3,
      _params$only_user = params.only_user,
      only_user = _params$only_user === void 0 ? false : _params$only_user,
      props = _objectWithoutPropertiesLoose(params, _excluded$3);
    var data = encryptParams(_extends({}, props, extra_params), ['base_infos', 'subject_name', 'password', 'identity_card', 'real_name']);
    var url = only_user ? WEB_AFF_URL.REGISTER_EMAIL_USER_ONLY : WEB_AFF_URL.REGISTER_EMAIL;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: url,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile used to register
   * @return {Promise} send result
   */
  this.sendMobileCode = function (params) {
    var mobile = params.mobile,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: 1
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile to be verified
   * @param {string} code - the mobile captcha
   * @return {Promise} verify result
   */
  this.verifyMobile = function (params) {
    var mobile = params.mobile,
      code = params.code,
      _params$extra_params5 = params.extra_params,
      extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      type: 1
    }, extra_params), ['mobile', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CHECK_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} ticket - the ticket gained from verification
   * @param {string} base_infos
   * @param {string} subject_name
   * @param {string} password
   * @param {string} identity_card
   * @param {string} real_name
   * @param {string} only_user - whether register user account only
   * @return {Promise} register result
   */
  this.registerByMobile = function (params) {
    var _params$extra_params6 = params.extra_params,
      extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6,
      _params$only_user2 = params.only_user,
      only_user = _params$only_user2 === void 0 ? false : _params$only_user2,
      props = _objectWithoutPropertiesLoose(params, _excluded2);
    var data = encryptParams(_extends({}, props, extra_params), ['base_infos', 'subject_name', 'password', 'identity_card', 'real_name']);
    var url = only_user ? WEB_AFF_URL.REGISTER_MOBILE_USER_ONLY : WEB_AFF_URL.REGISTER_MOBILE;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: url,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  var request = props.request;
  this.request = request;
};

var ForgetPwdAPI = function ForgetPwdAPI(props) {
  var _this = this;
  /**
   * @param {string} email - the email used to recall password
   * @return {Promise} send result
   */
  this.sendEmailCode = function (params) {
    var email = params.email,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      email: email,
      type: 4
    }, extra_params), ['email', 'type']);
    return _this.request({
      url: WEB_AFF_URL.SEND_EMAIL_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} mobile - the mobile used to recall password
   * @return {Promise} send result
   */
  this.sendMobileCode = function (params) {
    var mobile = params.mobile,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: 6
    }, extra_params), ['mobile', 'type']);
    return _this.request({
      url: WEB_AFF_URL.SEND_MOBILE_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} mobile - the mobile used to reset password
   * @param {string} code - the captcha
   * @param {string} password - new password
   * @return {Promise} reset result
   */
  this.mobileReset = function (params) {
    var mobile = params.mobile,
      code = params.code,
      password = params.password,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      password: password
    }, extra_params), ['mobile', 'code', 'password']);
    return _this.request({
      url: WEB_AFF_URL.RESET_BY_MOBILE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - the email used to reset password
   * @param {string} code - the captcha
   * @param {string} password - new password
   * @return {Promise} reset result
   */
  this.emailReset = function (params) {
    var email = params.email,
      code = params.code,
      password = params.password,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      password: password
    }, extra_params), ['email', 'code', 'password']);
    return _this.request({
      url: WEB_AFF_URL.RESET_BY_EMAIL,
      method: 'POST',
      data: data
    });
  };
  var request = props.request;
  this.request = request;
};

var _excluded$4 = ["extra_params"],
  _excluded2$1 = ["extra_params"];
var InviteAPI = function InviteAPI(props) {
  var _this = this;
  /**
   * @param {string} mobile - the mobile used to invite
   * @param {number} deputy_identity_id - character of invitation authorization
   * @param {string} invited_name - the name of the invited user
   * @param {string} next_url - the redirect url after accepting invitation
   * @param {string} link - landing page of invitation
   * @param {string} role_keys - keys of role, joined by ','
   * @param {string} permissions - joined by ','
   * @return {Promise} invite result
   */
  this.mobileInvite = function (params) {
    var _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params,
      props = _objectWithoutPropertiesLoose(params, _excluded$4);
    var data = encryptParams(_extends({}, props, extra_params), ['mobile']);
    return _this.request({
      url: WEB_AFF_URL.MOBILE_INVITE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - the email used to invite
   * @param {number} deputy_identity_id - character of invitation authorization
   * @param {string} invited_name - the name of the invited user
   * @param {string} next_url - the redirect url after accepting invitation
   * @param {string} link - landing page of invitation
   * @param {string} role_keys - keys of role, joined by ','
   * @param {string} permissions - joined by ','
   * @return {Promise} invite result
   */
  this.emailInvite = function (params) {
    var _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2,
      props = _objectWithoutPropertiesLoose(params, _excluded2$1);
    var data = encryptParams(_extends({}, props, extra_params), ['email']);
    return _this.request({
      url: WEB_AFF_URL.EMAIL_INVITE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - the email used to invite
   * @param {number} deputy_identity_id - character of invitation authorization
   * @param {string} invited_name - the name of the invited user
   * @param {string} role_keys - keys of role, joined by ','
   * @param {string} permissions - joined by ','
   * @return {Promise} invite result
   */
  // larkInvite = (params: {
  //   email: string;
  //   deputy_identity_id: number;
  //   invited_name: string;
  //   role_keys?: string;
  //   permissions?: string;
  //   extra_params?: object;
  // }) => {
  //   const { extra_params = {}, ...props } = params;
  //   const data = encryptParams(
  //     {
  //       ...props,
  //       ...extra_params,
  //     },
  //     ['email']
  //   );
  //   return this.request({
  //     url: WEB_AFF_URL.LARK_INVITE,
  //     method: 'POST',
  //     data,
  //   });
  // };
  /**
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @return {Promise} request result
   */
  this.getInvitationList = function (params) {
    var _params$page = params.page,
      page = _params$page === void 0 ? 1 : _params$page,
      _params$page_size = params.page_size,
      page_size = _params$page_size === void 0 ? 10 : _params$page_size,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: "" + WEB_AFF_URL.INVITE_LIST + page + "/",
        method: 'GET',
        data: _extends({
          page_size: page_size
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} invite_id - the invitation id
   * @return {Promise} cancel result
   */
  this.cancelInvitation = function (params) {
    var _params$invite_id = params.invite_id,
      invite_id = _params$invite_id === void 0 ? 0 : _params$invite_id,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CANCEL_INVITE,
        method: 'POST',
        data: _extends({
          invite_id: invite_id
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} invite_id - the invitation id
   * @param {string} next_url - the redirect url after accepting invitation
   * @return {Promise} resend result
   */
  this.resendInvitation = function (params) {
    var _params$invite_id2 = params.invite_id,
      invite_id = _params$invite_id2 === void 0 ? 0 : _params$invite_id2,
      _params$next_url = params.next_url,
      next_url = _params$next_url === void 0 ? '' : _params$next_url,
      _params$link = params.link,
      link = _params$link === void 0 ? '' : _params$link,
      _params$extra_params5 = params.extra_params,
      extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.RESEND_INVITE,
        method: 'POST',
        data: _extends({
          invite_id: invite_id,
          next_url: next_url,
          link: link
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} invite_id - the invitation id
   * @param {number} deputy_identity_id - character of invitation authorization
   * @param {string} deputy_name - inviter name
   * @return {Promise} update result
   */
  this.updateInvitation = function (params) {
    var _params$invite_id3 = params.invite_id,
      invite_id = _params$invite_id3 === void 0 ? 0 : _params$invite_id3,
      deputy_identity_id = params.deputy_identity_id,
      deputy_name = params.deputy_name,
      _params$extra_params6 = params.extra_params,
      extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    var data = encryptParams(_extends({
      invite_id: invite_id,
      deputy_identity_id: deputy_identity_id,
      deputy_name: deputy_name
    }, extra_params), ['deputy_name']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.UPDATE_INVITE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} invite_ticket - invitation ticket carried in the query of invitation link, only necessary when the user is not login
   * @return {Promise} check result
   */
  this.checkRegisterStatus = function (params) {
    var invite_ticket = params.invite_ticket,
      _params$extra_params7 = params.extra_params,
      extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CHECK_INVITE_VALID,
        method: 'POST',
        data: _extends({
          invite_ticket: invite_ticket
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} invite_ticket - invitation ticket carried in the query of invitation link, only necessary when the user is not login
   * @param {string} password - necessary when the user is new user
   * @return {Promise} accept result
   */
  this.acceptInvitation = function (params) {
    var invite_ticket = params.invite_ticket,
      password = params.password,
      extra = params.extra,
      _params$extra_params8 = params.extra_params,
      extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    var data = encryptParams(_extends({
      invite_ticket: invite_ticket,
      password: password,
      extra: extra
    }, extra_params), ['password', 'extra']);
    return _this.request({
      url: WEB_AFF_URL.ACCEPT_INVITE,
      method: 'POST',
      data: data
    });
  };
  var request = props.request;
  this.request = request;
};

var _excluded$5 = ["extra_params"],
  _excluded2$2 = ["extra_params"],
  _excluded3 = ["extra_params"];
var SubjectAPI = function SubjectAPI(props) {
  var _this = this;
  /**
   * @param {string} subject_name
   * @param {string} deputy_name - name of the principal of subject
   * @param {string} password
   * @param {string} username
   * @param {number} deputy_identity_id
   * @param {string} base_infos - basic info
   * @param {string} detail_infos
   * @return {Promise} create result
   */
  this.createByUsername = function (params) {
    var _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params,
      props = _objectWithoutPropertiesLoose(params, _excluded$5);
    var data = encryptParams(_extends({}, props, extra_params), ['subject_name', 'deputy_name', 'password', 'username', 'base_infos', 'detail_infos']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CREATE_BY_USERNAME,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} subject_name
   * @param {string} deputy_name - name of the principal of subject
   * @param {string} password
   * @param {string} mobile
   * @param {number} deputy_identity_id
   * @param {string} base_infos - basic info
   * @param {string} detail_infos
   * @return {Promise} create result
   */
  this.createByMobile = function (params) {
    var _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2,
      props = _objectWithoutPropertiesLoose(params, _excluded2$2);
    var data = encryptParams(_extends({}, props, extra_params), ['subject_name', 'deputy_name', 'password', 'mobile', 'base_infos', 'detail_infos']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CREATE_BY_MOBILE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} subject_name
   * @param {string} deputy_name - name of the principal of subject
   * @param {string} password
   * @param {string} email
   * @param {number} deputy_identity_id
   * @param {string} base_infos - basic info
   * @param {string} detail_infos
   * @return {Promise} create result
   */
  this.createByEmail = function (params) {
    var _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3,
      props = _objectWithoutPropertiesLoose(params, _excluded3);
    var data = encryptParams(_extends({}, props, extra_params), ['subject_name', 'deputy_name', 'password', 'email', 'base_infos', 'detail_infos']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CREATE_BY_EMAIL,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @param {number} deputy_identity_id
   * @return {Promise} request result
   */
  this.getSubjectList = function (params) {
    var _params$page = params.page,
      page = _params$page === void 0 ? 1 : _params$page,
      _params$page_size = params.page_size,
      page_size = _params$page_size === void 0 ? 10 : _params$page_size,
      deputy_identity_id = params.deputy_identity_id,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: "" + WEB_AFF_URL.SUBJECT_LIST + page + "/",
        method: 'GET',
        data: _extends({
          page_size: page_size,
          deputy_identity_id: deputy_identity_id
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @return {Promise} request result
   */
  this.getSubjectDeputyList = function (params) {
    var _params$page2 = params.page,
      page = _params$page2 === void 0 ? 1 : _params$page2,
      _params$page_size2 = params.page_size,
      page_size = _params$page_size2 === void 0 ? 10 : _params$page_size2,
      _params$extra_params5 = params.extra_params,
      extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: "" + WEB_AFF_URL.SUBJECT_DEPUTY_LIST + page + "/",
        method: 'GET',
        data: _extends({
          page_size: page_size
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @return {Promise} request result
   */
  this.getSubjectIdentityList = function (params) {
    var _params$page3 = params.page,
      page = _params$page3 === void 0 ? 1 : _params$page3,
      _params$page_size3 = params.page_size,
      page_size = _params$page_size3 === void 0 ? 10 : _params$page_size3,
      _params$extra_params6 = params.extra_params,
      extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: "" + WEB_AFF_URL.SUBJECT_IDENTITY_LIST + page + "/",
        method: 'GET',
        data: _extends({
          page_size: page_size
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} sec_user_id - encrypted uid
   * @param {number} deputy_identity_id
   * @param {string} deputy_name
   * @param {string} user_identity_id
   * @return {Promise} update result
   */
  this.updateDeputyInfo = function (params) {
    var sec_user_id = params.sec_user_id,
      deputy_identity_id = params.deputy_identity_id,
      deputy_name = params.deputy_name,
      user_identity_id = params.user_identity_id,
      _params$extra_params7 = params.extra_params,
      extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    var data = encryptParams(_extends({
      sec_user_id: sec_user_id,
      deputy_identity_id: deputy_identity_id,
      deputy_name: deputy_name,
      user_identity_id: user_identity_id
    }, extra_params), ['deputy_name', 'user_identity_id']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.UPDATE_DEPUTY_INFO,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} sec_user_id - encrypted uid
   * @param {string} user_identity_id
   * @param {number} is_frozen - whether to freeze
   * @return {Promise} freeze result
   */
  this.freezeDeputy = function (params) {
    var sec_user_id = params.sec_user_id,
      user_identity_id = params.user_identity_id,
      _params$is_frozen = params.is_frozen,
      is_frozen = _params$is_frozen === void 0 ? 0 : _params$is_frozen,
      _params$extra_params8 = params.extra_params,
      extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    var data = encryptParams(_extends({
      sec_user_id: sec_user_id,
      user_identity_id: user_identity_id,
      is_frozen: is_frozen
    }, extra_params), ['sec_user_id', 'user_identity_id']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.FREEZE_DEPUTY,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} sec_user_id - encrypted uid
   * @param {string} user_identity_id
   * @return {Promise} delete result
   */
  this.deleteDeputy = function (params) {
    var sec_user_id = params.sec_user_id,
      user_identity_id = params.user_identity_id,
      _params$extra_params9 = params.extra_params,
      extra_params = _params$extra_params9 === void 0 ? {} : _params$extra_params9;
    var data = encryptParams(_extends({
      sec_user_id: sec_user_id,
      user_identity_id: user_identity_id
    }, extra_params), ['user_identity_id']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.DELETE_DEPUTY,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} sec_subject_uid - encrypted subject uid
   * @param {string} subject_name
   * @param {string} base_infos
   * @param {string} detail_infos
   * @return {Promise} update result
   */
  this.updateSubjectInfo = function (params) {
    var sec_subject_uid = params.sec_subject_uid,
      subject_name = params.subject_name,
      base_infos = params.base_infos,
      detail_infos = params.detail_infos,
      _params$extra_params10 = params.extra_params,
      extra_params = _params$extra_params10 === void 0 ? {} : _params$extra_params10;
    var data = encryptParams(_extends({
      sec_subject_uid: sec_subject_uid,
      subject_name: subject_name,
      base_infos: base_infos,
      detail_infos: detail_infos
    }, extra_params), ['sec_subject_uid', 'subject_name', 'base_infos', 'detail_infos']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.UPDATE_SUBJECT_INFO,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} sec_subject_uid - encrypted subject uid
   * @param {number} is_frozen - whether to freeze
   * @return {Promise} freeze result
   */
  this.freezeSubject = function (params) {
    var sec_subject_uid = params.sec_subject_uid,
      _params$is_frozen2 = params.is_frozen,
      is_frozen = _params$is_frozen2 === void 0 ? 0 : _params$is_frozen2,
      _params$extra_params11 = params.extra_params,
      extra_params = _params$extra_params11 === void 0 ? {} : _params$extra_params11;
    var data = encryptParams(_extends({
      sec_subject_uid: sec_subject_uid,
      is_frozen: is_frozen
    }, extra_params), ['sec_subject_uid']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.FREEZE_SUBJECT,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  var request = props.request;
  this.request = request;
};

var ResourceAPI = function ResourceAPI(props) {
  var _this = this;
  /**
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @param {number} subject_uid - id of subject
   * @return {Promise} request result
   */
  this.getResourceList = function (params) {
    var _params$page = params.page,
      page = _params$page === void 0 ? 1 : _params$page,
      _params$page_size = params.page_size,
      page_size = _params$page_size === void 0 ? 10 : _params$page_size,
      subject_uid = params.subject_uid,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: "" + WEB_AFF_URL.RESOURCE_LIST + page + "/",
        method: 'GET',
        data: _extends({
          page_size: page_size,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  var request = props.request;
  this.request = request;
};

var RoleAPI = function RoleAPI(props) {
  var _this = this;
  /**
   * @param {string} role_name - name
   * @param {string} permissions - concatenation of resources permissions
   * @param {number} subject_uid - id of subject
   * @return {Promise} create result
   */
  this.createRole = function (params) {
    var role_name = params.role_name,
      permissions = params.permissions,
      subject_uid = params.subject_uid,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CREATE_ROLE,
        method: 'POST',
        data: _extends({
          role_name: role_name,
          permissions: permissions,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} role_key - id of role
   * @param {string} role_name - name
   * @param {string} permissions - concatenation of resources permissions
   * @param {string} description - description
   * @param {number} subject_uid - id of subject
   * @return {Promise} update result
   */
  this.updateRole = function (params) {
    var role_key = params.role_key,
      role_name = params.role_name,
      permissions = params.permissions,
      description = params.description,
      subject_uid = params.subject_uid,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.UPDATE_ROLE,
        method: 'POST',
        data: _extends({
          role_key: role_key,
          role_name: role_name,
          permissions: permissions,
          description: description,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} role_key - id of role
   * @param {number} subject_uid - id of subject
   * @return {Promise} ban result
   */
  this.banRole = function (params) {
    var role_key = params.role_key,
      subject_uid = params.subject_uid,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.BAN_ROLE,
        method: 'POST',
        data: _extends({
          role_key: role_key,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} subject_uid - id of subject
   * @return {Promise} request result
   */
  this.getRoleList = function (params) {
    var subject_uid = params.subject_uid,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.ROLE_LIST,
        method: 'GET',
        data: _extends({
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} role_key - id of role
   * @param {number} subject_uid - id of subject
   * @return {Promise} request result
   */
  this.getRoleInfo = function (params) {
    var role_key = params.role_key,
      subject_uid = params.subject_uid,
      _params$extra_params5 = params.extra_params,
      extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.ROLE_INFO,
        method: 'GET',
        data: _extends({
          role_key: role_key,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  var request = props.request;
  this.request = request;
};

var UserAPI = function UserAPI(props) {
  var _this = this;
  /**
   * @param {string} role_key - id of role
   * @param {string} sec_user_id - encrypted user id
   * @param {string} name - user name
   * @param {number} identity_id - id of identity
   * @param {number} subject_uid - id of subject
   * @return {Promise} create result
   */
  this.createUserWithRole = function (params) {
    var role_key = params.role_key,
      sec_user_id = params.sec_user_id,
      name = params.name,
      identity_id = params.identity_id,
      subject_uid = params.subject_uid,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CREATE_USER_WITH_ROLE,
        method: 'POST',
        data: _extends({
          role_key: role_key,
          sec_user_id: sec_user_id,
          name: name,
          identity_id: identity_id,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} role_key - id of role
   * @param {string} sec_user_identity_ids - encrypted user id seperated by ','
   * @param {number} subject_uid - id of subject
   * @return {Promise} add result
   */
  this.addUserRole = function (params) {
    var role_key = params.role_key,
      sec_user_identity_ids = params.sec_user_identity_ids,
      subject_uid = params.subject_uid,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.ADD_USER_ROLE,
        method: 'POST',
        data: _extends({
          role_key: role_key,
          sec_user_identity_ids: sec_user_identity_ids,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} role_key - id of role
   * @param {string} sec_user_identity_ids - encrypted user id seperated by ','
   * @param {number} subject_uid - id of subject
   * @return {Promise} delete result
   */
  this.deleteUserRole = function (params) {
    var role_key = params.role_key,
      sec_user_identity_ids = params.sec_user_identity_ids,
      subject_uid = params.subject_uid,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.DELETE_USER_ROLE,
        method: 'POST',
        data: _extends({
          role_key: role_key,
          sec_user_identity_ids: sec_user_identity_ids,
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} subject_uid - id of subject
   * @return {Promise} request result
   */
  this.getUserRoleList = function (params) {
    var subject_uid = params.subject_uid,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.USER_ROLE_LIST,
        method: 'GET',
        data: _extends({
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} subject_uid - id of subject
   * @param {number} identity_id - id of identity
   * @param {number} page - page number
   * @param {number} page_size - page size
   * @return {Promise} request result
   */
  this.getAllUserRoleList = function (params) {
    var subject_uid = params.subject_uid,
      identity_id = params.identity_id,
      _params$page = params.page,
      page = _params$page === void 0 ? 1 : _params$page,
      _params$page_size = params.page_size,
      page_size = _params$page_size === void 0 ? 10 : _params$page_size,
      _params$extra_params5 = params.extra_params,
      extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: "" + WEB_AFF_URL.ALL_USER_ROLE_LIST + page + "/",
        method: 'GET',
        data: _extends({
          subject_uid: subject_uid,
          identity_id: identity_id,
          page_size: page_size
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} subject_uid - id of subject
   * @return {Promise} request result
   */
  this.getUserPermissions = function (params) {
    var subject_uid = params.subject_uid,
      _params$extra_params6 = params.extra_params,
      extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.USER_PERMISSIONS,
        method: 'GET',
        data: _extends({
          subject_uid: subject_uid
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  var request = props.request;
  this.request = request;
};

var _excluded$6 = ["extra_params"];
var SuperAPI = function SuperAPI(props) {
  var _this = this;
  /**
   * @return {Promise} send result
   */
  this.sendCodeToOldManager = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params = params,
      _params$extra_params = _params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      type: 22
    }, extra_params), ['type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @return {Promise} send result
   */
  this.sendEmailCodeToOldManager = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params2 = params,
      _params2$extra_params = _params2.extra_params,
      extra_params = _params2$extra_params === void 0 ? {} : _params2$extra_params;
    var data = encryptParams(_extends({
      type: 6
    }, extra_params), ['type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} code - the captcha
   * @return {Promise} verify result
   */
  this.verifyOldManagerMobile = function (params) {
    var code = params.code,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      code: code,
      type: 22
    }, extra_params), ['code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.VERIFY_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} code - the captcha
   * @return {Promise} verify result
   */
  this.verifyOldManagerEmail = function (params) {
    var code = params.code,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      code: code,
      type: 6
    }, extra_params), ['code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.VERIFY_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - mobile number
   * @param {string} verify_ticket - the ticket returned by verification
   * @return {Promise} send result
   */
  this.sendCodeToNewManager = function (params) {
    var mobile = params.mobile,
      verify_ticket = params.verify_ticket,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      mobile: mobile,
      verify_ticket: verify_ticket,
      type: 101
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - email address
   * @param {string} verify_ticket - the ticket returned by verification
   * @return {Promise} send result
   */
  this.sendEmailCodeToNewManager = function (params) {
    var email = params.email,
      verify_ticket = params.verify_ticket,
      _params$extra_params5 = params.extra_params,
      extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var data = encryptParams(_extends({
      email: email,
      verify_ticket: verify_ticket,
      type: 101
    }, extra_params), ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - mobile number
   * @param {number} code - the captcha
   * @return {Promise} verify result
   */
  this.verifyNewManagerMobile = function (params) {
    var mobile = params.mobile,
      code = params.code,
      _params$extra_params6 = params.extra_params,
      extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      type: 101
    }, extra_params), ['mobile', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CHECK_MOBILE_CODE,
        method: 'GET',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - email address
   * @param {number} code - the captcha
   * @return {Promise} verify result
   */
  this.verifyNewManagerEmail = function (params) {
    var email = params.email,
      code = params.code,
      _params$extra_params7 = params.extra_params,
      extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      type: 101
    }, extra_params), ['email', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_AFF_URL.CHECK_EMAIL_CODE,
        method: 'GET',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} new_user_name - name of new manager
   * @param {string} new_admin_verify_ticket - verify ticket of new manager
   * @param {string} old_admin_verify_ticket - the ticket returned by verification
   * @param {number} old_admin_target_identity_id - the identity id of old manager after transfer
   * @param {string} new_admin_sec_user_id - the encrypted user id of new manager
   * @param {string} new_admin_sec_user_identity_id - the encrypted user identity id of new manager
   * @return {Promise} verify result
   */
  this.transferManager = function (params) {
    var _params$extra_params8 = params.extra_params,
      extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8,
      props = _objectWithoutPropertiesLoose(params, _excluded$6);
    return _this.request({
      url: WEB_AFF_URL.TRANSFER_MANAGER,
      method: 'POST',
      data: _extends({}, props, extra_params)
    });
  };
  var request = props.request;
  this.request = request;
};

var _excluded$7 = ["extra_params"],
  _excluded2$3 = ["extra_params"],
  _excluded3$1 = ["extra_params"];
var LoginAPI$1 = function LoginAPI(props) {
  var _this = this;
  /**
   * @param {string} mobile - the mobile used to login
   * @return {Promise} send result
   */
  this.sendCode = function (params) {
    var mobile = params.mobile,
      _params$registerOnly = params.registerOnly,
      registerOnly = _params$registerOnly === void 0 ? false : _params$registerOnly,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: registerOnly ? 16 : 24
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile used to login
   * @param {string} code - the captcha
   * @param {boolean} login_only - 'true' for only login, 'false' for register and login
   * @return {Promise} login result
   */
  this.smsLogin = function (params) {
    var mobile = params.mobile,
      code = params.code,
      _params$login_only = params.login_only,
      login_only = _params$login_only === void 0 ? false : _params$login_only,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code
    }, extra_params), ['mobile', 'code']);
    var url = login_only ? WEB_URL.SMS_LOGIN_ONLY : WEB_URL.SMS_LOGIN;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: url,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile used to login
   * @param {string} sms_code_key - the ticket gained from sms login only
   * @return {Promise} login result
   */
  this.smsLoginContinue = function (params) {
    var mobile = params.mobile,
      sms_code_key = params.sms_code_key,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      mobile: mobile,
      sms_code_key: sms_code_key
    }, extra_params), ['mobile', 'sms_code_key']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SMS_LOGIN_CONTINUE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} platform_app_id - the id of third party
   * @param {string} next - redirect url after successful login
   * @return {Promise} login result
   */
  this.webLogin = function (params) {
    var platform_app_id = params.platform_app_id,
      next = params.next,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SMS_LOGIN_CONTINUE,
        method: 'POST',
        data: _extends({
          platform_app_id: platform_app_id,
          next: next
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email used to login
   * @param {string} password - corresponding password
   * @return {Promise} login result
   */
  this.emailLogin = function (params) {
    var email = params.email,
      password = params.password,
      _params$extra_params5 = params.extra_params,
      extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var data = encryptParams(_extends({
      email: email,
      password: password
    }, extra_params), ['email', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.EMAIL_LOGIN,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email to login
   * @param {string} code - the captcha
   * @param {string} service
   * @return {Promise} login result
   */
  this.emailCodeLogin = function (params) {
    var email = params.email,
      code = params.code,
      _params$extra_params6 = params.extra_params,
      extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      ect_type: 13
    }, extra_params), ['email', 'code']);
    return _this.request({
      url: WEB_URL.EMAIL_CODE_LOGIN,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} account - the account to login
   * @param {string} password - corresponding password
   * @return {Promise} login result
   */
  this.pwdLogin = function (params) {
    var username = params.username,
      mobile = params.mobile,
      email = params.email,
      account = params.account,
      password = params.password,
      _params$extra_params7 = params.extra_params,
      extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    var data = encryptParams(_extends({
      username: username,
      mobile: mobile,
      email: email,
      account: account,
      password: password
    }, extra_params), ['username', 'mobile', 'email', 'account', 'password']);
    return _this.request({
      url: WEB_URL.PWD_LOGIN,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {number} platform_app_id - the app id of the third party used to login
   * @param {string} code - authorization code
   * @param {string} access_token - third-party authorization token
   * @param {string} access_token_secret - id token, only neccessary when using google to login
   * @param {string} openid - third-party openid, used with access_token
   * @param {string} profile_key - third-party ticket that preserves information temporaily, used when the login progress is blocked
   * @param {boolean} login_only - whether to login only, not allowing to register
   * @return {Promise} login result
   */
  this.authLogin = function (params) {
    var platform_app_id = params.platform_app_id,
      code = params.code,
      access_token = params.access_token,
      access_token_secret = params.access_token_secret,
      openid = params.openid,
      profile_key = params.profile_key,
      _params$login_only2 = params.login_only,
      login_only = _params$login_only2 === void 0 ? false : _params$login_only2,
      _params$extra_params8 = params.extra_params,
      extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: login_only ? WEB_URL.AUTH_LOGIN_ONLY : WEB_URL.AUTH_LOGIN,
        method: 'POST',
        data: _extends({
          platform_app_id: platform_app_id,
          code: code,
          access_token: access_token,
          access_token_secret: access_token_secret,
          openid: openid,
          profile_key: profile_key
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  this.webShareLogin = function (params) {
    var _params$extra_params9 = params.extra_params,
      extra_params = _params$extra_params9 === void 0 ? {} : _params$extra_params9,
      props = _objectWithoutPropertiesLoose(params, _excluded$7);
    return _this.request({
      url: WEB_URL.WEB_SHARE_LOGIN,
      method: 'POST',
      data: _extends({}, extra_params, props)
    });
  };
  /**
   * @param {string} access_token - third-party authorization token
   * @param {string} access_token_secret - id token, only neccessary when using google to login
   * @param {string} code - authorization code
   * @param {number} expires_in - expires time of access_token
   * @param {string} openid - third-party openid, used with access_token
   * @param {number} platform_app_id - the app id of the third party used to login
   * @param {string} platform - name of third party platform
   * @param {boolean} need_plaintext - whether to return mobile in plaintext
   * @param {string} profile_key - third-party ticket that preserves information temporaily
   * @return {Promise} login result
   */
  this.getOauthMobile = function (params) {
    var access_token = params.access_token,
      access_token_secret = params.access_token_secret,
      code = params.code,
      expires_in = params.expires_in,
      openid = params.openid,
      platform_app_id = params.platform_app_id,
      platform = params.platform,
      _params$need_plaintex = params.need_plaintext,
      need_plaintext = _params$need_plaintex === void 0 ? false : _params$need_plaintex,
      profile_key = params.profile_key,
      _params$extra_params10 = params.extra_params,
      extra_params = _params$extra_params10 === void 0 ? {} : _params$extra_params10;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.MOBILE_OAUTH,
        method: 'POST',
        data: _extends({
          access_token: access_token,
          access_token_secret: access_token_secret,
          code: code,
          expires_in: expires_in,
          openid: openid,
          platform_app_id: platform_app_id,
          platform: platform,
          need_plaintext: need_plaintext,
          profile_key: profile_key
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} platform_app_id - the app id of the third party used to login
   * @param {string} code - authorization code
   * @param {string} profile_key - third-party ticket that preserves information temporaily, used when the login progress is blocked
   * @param {string} mobile - phone number
   * @param {string} sms_code - captcha
   * @return {Promise} login result
   */
  this.authBindLogin = function (params) {
    var platform_app_id = params.platform_app_id,
      code = params.code,
      mobile = params.mobile,
      sms_code = params.sms_code,
      sms_code_key = params.sms_code_key,
      profile_key = params.profile_key,
      _params$extra_params11 = params.extra_params,
      extra_params = _params$extra_params11 === void 0 ? {} : _params$extra_params11;
    var data = encryptParams(_extends({
      platform_app_id: platform_app_id,
      code: code,
      mobile: mobile,
      sms_code: sms_code,
      sms_code_key: sms_code_key,
      profile_key: profile_key
    }, extra_params), ['mobile', 'sms_code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.AUTH_BIND_ONLY,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile used to login
   * @param {string} code - the captcha
   * @param {string} profile_key - a parameter returned by login_only interface
   */
  this.mobileBindLogin = function (params) {
    var code = params.code,
      mobile = params.mobile,
      profile_key = params.profile_key,
      _params$extra_params12 = params.extra_params,
      extra_params = _params$extra_params12 === void 0 ? {} : _params$extra_params12;
    var data = encryptParams(_extends({
      code: code,
      mobile: mobile,
      profile_key: profile_key
    }, extra_params), ['mobile', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.MOBILE_BIND_ONLY,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} next - the redirect url after successful logout
   */
  this.logout = function (params) {
    var _params$next = params.next,
      next = _params$next === void 0 ? '/' : _params$next,
      _params$need_redirect = params.need_redirect,
      need_redirect = _params$need_redirect === void 0 ? 1 : _params$need_redirect;
    if (need_redirect) {
      var _get;
      var _aid = ((_get = get('initProps')) === null || _get === void 0 ? void 0 : _get.aid) || '';
      var nextUrl = encodeURIComponent(next);
      window.location.href = WEB_URL.LOGOUT + "?account_sdk_source=web&aid=" + _aid + "&next=" + nextUrl;
      return;
    } else {
      return _this.request({
        url: WEB_URL.LOGOUT,
        data: {
          need_redirect: need_redirect
        }
      });
    }
  };
  /**
   * @param {string} email - the email used to login
   * @param {string} next - the url attached to the email
   * @param {string} password - corresponding password
   * @return {Promise} send result
   */
  this.sendEmailCode = function (params) {
    var email = params.email,
      next = params.next,
      password = params.password,
      _params$extra_params13 = params.extra_params,
      extra_params = _params$extra_params13 === void 0 ? {} : _params$extra_params13;
    var data = encryptParams(_extends({
      email: email,
      next: next,
      password: password,
      type: 1
    }, extra_params), ['email', 'password', 'type']);
    return _this.request({
      url: WEB_URL.SEND_EMAIL_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - the email used to login
   * @param {string} next - the url attached to the email
   * @return {Promise} send result
   */
  this.sendEmailLoginCode = function (params) {
    var email = params.email,
      next = params.next,
      _params$extra_params14 = params.extra_params,
      extra_params = _params$extra_params14 === void 0 ? {} : _params$extra_params14;
    var data = encryptParams(_extends({
      email: email,
      next: next,
      type: 13
    }, extra_params), ['email', 'type']);
    return _this.request({
      url: WEB_URL.SEND_EMAIL_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - the email used to login
   * @param {string} code - the captcha
   * @param {string} password - corresponding password
   * @return {Promise} send result
   */
  this.emailRegister = function (params) {
    var email = params.email,
      code = params.code,
      password = params.password,
      _params$ifLogin = params.ifLogin,
      ifLogin = _params$ifLogin === void 0 ? false : _params$ifLogin,
      _params$extra_params15 = params.extra_params,
      extra_params = _params$extra_params15 === void 0 ? {} : _params$extra_params15;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      password: password,
      type: 1
    }, extra_params), ['email', 'password', 'type', 'code']);
    return _this.request({
      url: ifLogin ? WEB_URL.EMAIL_REGISTER_LOGIN : WEB_URL.EMAIL_REGISTER,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} mobile - the mobile used to login
   * @param {string} code - the captcha
   * @param {string} password - corresponding password
   * @return {Promise} register result
   */
  this.mobileRegister = function (params) {
    var mobile = params.mobile,
      code = params.code,
      password = params.password,
      _params$extra_params16 = params.extra_params,
      extra_params = _params$extra_params16 === void 0 ? {} : _params$extra_params16;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      password: password,
      type: 16
    }, extra_params), ['mobile', 'code', 'password', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.MOBILE_REGISTER,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile used to login
   * @param {string} sms_code - the sms captcha
   * @param {string} email - the email used to login
   * @param {string} email_code - the email captcha
   * @param {string} password - corresponding password
   * @param {string} verify_ticket - the ticket returned by server during last verification process
   * @return {Promise} register result
   */
  this.mobileEmailRegister = function (params) {
    var mobile = params.mobile,
      sms_code = params.sms_code,
      email = params.email,
      email_code = params.email_code,
      password = params.password,
      verify_ticket = params.verify_ticket,
      _params$extra_params17 = params.extra_params,
      extra_params = _params$extra_params17 === void 0 ? {} : _params$extra_params17;
    var data = encryptParams(_extends({
      mobile: mobile,
      sms_code: sms_code,
      email: email,
      email_code: email_code,
      password: password,
      verify_ticket: verify_ticket,
      sms_type: 16,
      ect_type: 1
    }, extra_params), ['mobile', 'sms_code', 'sms_type', 'email', 'email_code', 'ect_type', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.MOBILE_EMAIL_REGISTER,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @return {Promise} check result
   */
  this.checkLogin = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params = params,
      _params$extra_params18 = _params.extra_params,
      extra_params = _params$extra_params18 === void 0 ? {} : _params$extra_params18;
    return _this.request({
      url: WEB_URL.CHECK_LOGIN,
      method: 'GET',
      data: extra_params
    });
  };
  /**
   * @param {string} code - user code returned by open service
   * @param {string} profile_key - user code returned by other process
   * @param {number} platform_app_id - apply for configuration in appcloud
   * @param {string} platform - third-party name
   * @param {number} need_mobile - whether synchronize the mobile of third-party account
   * @param {number} check_mobile - whether restrict old user to bind mobile forcely
   * @param {number} change_bind - whether rebind forcely when conflict occurs
   * @return {Promise} login result
   */
  this.bindWithMobileLogin = function (params) {
    var _params$extra_params19 = params.extra_params,
      extra_params = _params$extra_params19 === void 0 ? {} : _params$extra_params19,
      props = _objectWithoutPropertiesLoose(params, _excluded2$3);
    return _this.request({
      url: WEB_URL.BIND_WITH_MOBILE_LOGIN,
      method: 'POST',
      data: _extends({}, extra_params, props)
    });
  };
  /**
   * @param {string} access_token
   * @param {string} access_token_secret
   * @param {string} code - user code returned by open service
   * @param {number} openid
   * @param {string} profile_key - user code returned by other process
   * @param {number} platform_app_id - apply for configuration in appcloud
   * @param {string} redirect_uri
   * @return {Promise} login result
   */
  this.bindWithEmailLogin = function (params) {
    var _params$extra_params20 = params.extra_params,
      extra_params = _params$extra_params20 === void 0 ? {} : _params$extra_params20,
      props = _objectWithoutPropertiesLoose(params, _excluded3$1);
    return _this.request({
      url: WEB_URL.BIND_WITH_EMAIL_LOGIN,
      method: 'POST',
      data: _extends({}, extra_params, props)
    });
  };
  /**
   * @param {number} platform_app_id - apply for configuration in appcloud
   * @param {string} next - redirect url after successful login
   * @param {number} use_local_host
   * @param {string} action - login_only || ''
   */
  this.thirdAuth = function (params) {
    var _get2;
    var platform_app_id = params.platform_app_id,
      _params$next2 = params.next,
      next = _params$next2 === void 0 ? '/' : _params$next2,
      _params$use_local_hos = params.use_local_host,
      use_local_host = _params$use_local_hos === void 0 ? 0 : _params$use_local_hos,
      action = params.action;
    var aid = ((_get2 = get('initProps')) === null || _get2 === void 0 ? void 0 : _get2.aid) || '';
    var nextUrl = encodeURIComponent(next);
    window.location.href = WEB_URL.THIRD_AUTH + "?account_sdk_source=web&aid=" + aid + "&next=" + nextUrl + "&platform_app_id=" + platform_app_id + "&use_local_host=" + use_local_host + "&action=" + action;
  };
  /**
   * @param {string} username
   * @param {string} password
   * @return {Promise} register result
   */
  this.usernameRegister = function (params) {
    var username = params.username,
      password = params.password,
      _params$extra_params21 = params.extra_params,
      extra_params = _params$extra_params21 === void 0 ? {} : _params$extra_params21;
    var data = encryptParams(_extends({
      username: username,
      password: password
    }, extra_params), ['username', 'password']);
    return _this.request({
      url: WEB_URL.USERNAME_REGISTER,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - user email
   * @param {string} password - password
   * @param {number} next_url - redirect url
   * @param {string} recaptcha_token - token
   * @return {Promise} login result
   */
  this.emailRegisterNoVerifyV2 = function (params) {
    var email = params.email,
      password = params.password,
      next_url = params.next_url,
      recaptcha_token = params.recaptcha_token,
      _params$extra_params22 = params.extra_params,
      extra_params = _params$extra_params22 === void 0 ? {} : _params$extra_params22;
    var data = encryptParams(_extends({
      email: email,
      password: password,
      next_url: next_url,
      recaptcha_token: recaptcha_token
    }, extra_params), ['email', 'password', 'recaptcha_token']);
    return _this.request({
      url: WEB_URL.EMAIL_REGISTER_NO_VERIFY_V2,
      method: 'POST',
      data: data
    });
  };
  /**
   * [wap login]
   * @param {string} origin request domain, this interface isn't sso
   * @param {string} platform_app_id the thrid appId
   * @param {string} next rederict url
   * @param {string} type default 'sso'
   * @param {string} use_local_host default 1
   * @param {string} scopes default 'user_info'
   * @param {string} url_params
   */
  this.wapLogin = function (params) {
    var _params$origin = params.origin,
      origin = _params$origin === void 0 ? '' : _params$origin,
      _params$type = params.type,
      type = _params$type === void 0 ? 'web' : _params$type,
      use_local_host = params.use_local_host,
      _params$scopes = params.scopes,
      scopes = _params$scopes === void 0 ? 'user_info' : _params$scopes,
      next = params.next,
      _params$url_params = params.url_params,
      url_params = _params$url_params === void 0 ? '' : _params$url_params,
      platform_app_id = params.platform_app_id,
      _params$platform = params.platform,
      platform = _params$platform === void 0 ? '' : _params$platform,
      _params$replace = params.replace,
      replace = _params$replace === void 0 ? false : _params$replace;
    var service = encodeURIComponent(next);
    var realNext = encodeURIComponent(_this.host + "/auth/login_success/?service=" + service);
    var paramMap = {
      aid: _this.aid,
      type: type,
      use_local_host: use_local_host,
      scopes: scopes,
      next: realNext,
      url_params: url_params,
      platform_app_id: platform_app_id,
      platform: platform
    };
    var query = '';
    var len = Object.keys(paramMap).length;
    Object.keys(paramMap).forEach(function (key, index) {
      if (len === index + 1) {
        query += key + "=" + paramMap[key];
      } else {
        query += key + "=" + paramMap[key] + "&";
      }
    });
    var redirectUrl = "" + origin + WEB_URL.AUTH_LOGIN_URL + "?" + query;
    // open url in current window
    if (replace) {
      window.location.href = redirectUrl;
    } else {
      // TODO
      var childWindow = window.open(redirectUrl, '_blank');
    }
  };
  /**
   * [register - bind verify info]
   * @param {string} auth_ticket ticket from certification platform
   * @param {string} verify_ticket ticket from passport
   * @param {string} token token that identify user
   * @param {string} scene scene like 'shop_guide_bind'
   * @param {string} user_type such as, 0 for normal user, 1 for lark user, 2 for xxx employee, 3 for xxx shop guide
   */
  this.bindVerifyInfo = function (params) {
    var auth_ticket = params.auth_ticket,
      verify_ticket = params.verify_ticket,
      token = params.token,
      scene = params.scene,
      user_type = params.user_type,
      _params$extra_params23 = params.extra_params,
      extra_params = _params$extra_params23 === void 0 ? {} : _params$extra_params23;
    return _this.request({
      url: COMMON_URL.BIND_VERIFY_INFO,
      method: 'GET',
      data: _extends({
        auth_ticket: auth_ticket,
        verify_ticket: verify_ticket,
        token: token,
        scene: scene,
        user_type: user_type
      }, extra_params)
    });
  };
  var request = props.request,
    host = props.host,
    aid = props.aid;
  this.request = request;
  this.host = host;
  this.aid = aid;
};

var QrCodeLoginAPI = /*#__PURE__*/function () {
  function QrCodeLoginAPI(props) {
    var request = props.request;
    this.request = request;
  }
  /**
   * [get qrcode url]
   * @param {string} next redirect url after login success
   */
  var _proto = QrCodeLoginAPI.prototype;
  _proto.getQrcode = function getQrcode(params) {
    var next = params.next;
    return this.request({
      url: WEB_URL.GET_QRCODE + "?next=" + encodeURIComponent(next),
      method: 'GET'
    });
  }
  /**
   * [query qrCode status]
   * @param {string} next	 redirect url after login success
   * @param {string} token result of GetQrcode
   */;
  _proto.checkQrconnect = function checkQrconnect(params) {
    var next = params.next,
      token = params.token,
      _params$baseURL = params.baseURL,
      baseURL = _params$baseURL === void 0 ? '' : _params$baseURL;
    return this.request({
      url: "" + baseURL + WEB_URL.CHECK_QRCONNECT + "?next=" + encodeURIComponent(next),
      method: 'GET',
      data: {
        // next: encodeURIComponent(next),
        token: token
      }
    });
  };
  return QrCodeLoginAPI;
}();

var BindAPI = function BindAPI(props) {
  var _this = this;
  /**
   * @param {string} mobile - the mobile about to bind
   * @param {number} unbind_exist - whether unbind forcely when the mobile is already bound to another account
   * @param {object} extra_params - extra params
   * @return {Promise} send result
   */
  this.sendCode = function (params) {
    var mobile = params.mobile,
      _params$unbind_exist = params.unbind_exist,
      unbind_exist = _params$unbind_exist === void 0 ? 0 : _params$unbind_exist,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: 17,
      unbind_exist: unbind_exist
    }, extra_params), ['mobile', 'type', 'unbind_exist']);
    return _this.request({
      url: WEB_URL.SEND_MOBILE_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} mobile - the mobile about to bind
   * @param {string} code - the captcha
   * @param {string} password - if you want to set password
   * @param {number} unbind_exist - whether unbind forcely when the mobile is already bound to another account
   * @return {Promise} bind result
   */
  this.bindMobile = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params = params,
      mobile = _params.mobile,
      code = _params.code,
      password = _params.password,
      verify_ticket = _params.verify_ticket,
      _params$unbind_exist2 = _params.unbind_exist,
      unbind_exist = _params$unbind_exist2 === void 0 ? 0 : _params$unbind_exist2,
      _params$extra_params2 = _params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      password: password,
      verify_ticket: verify_ticket,
      unbind_exist: unbind_exist,
      type: 17
    }, extra_params), ['mobile', 'code', 'password', 'unbind_exist', 'type']);
    return _this.request({
      url: WEB_URL.MOBILE_BIND,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - the email about to bind
   * @return {Promise} bind result
   */
  this.sendEmailCode = function (params) {
    var email = params.email,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      email: email,
      type: 8
    }, extra_params), ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email about to bind
   * @param {string} code - the captcha
   * @return {Promise} bind result
   */
  this.bindEmail = function (params) {
    var email = params.email,
      code = params.code,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      email: email,
      code: code
    }, extra_params), ['email', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.EMAIL_BIND,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} platform_app_id - the app id of the third party about to bind
   * @param {string} code - authorization code
   * @param {string} access_token - third-party authorization token
   * @param {string} access_token_secret - id token
   * @param {string} openid - third-party openid, used with access_token, only neccessary for google,facebook,google
   * @param {string} profile_key - third-party ticket that preserves information temporaily, used when the login progress is blocked
   * @return {Promise} bind result
   */
  this.bindAuth = function (params) {
    var platform_app_id = params.platform_app_id,
      code = params.code,
      access_token = params.access_token,
      access_token_secret = params.access_token_secret,
      openid = params.openid,
      profile_key = params.profile_key,
      _params$extra_params5 = params.extra_params,
      extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.AUTH_BIND,
        method: 'POST',
        data: _extends({
          platform_app_id: platform_app_id,
          code: code,
          access_token: access_token,
          access_token_secret: access_token_secret,
          openid: openid,
          profile_key: profile_key
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} platform - the platform about to unbind
   * @return {Promise} unbind result
   */
  this.unbindAuth = function (params) {
    var platform = params.platform,
      _params$extra_params6 = params.extra_params,
      extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.AUTH_UNBIND,
        method: 'POST',
        data: _extends({
          platform: platform
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} platform_app_id - the app id of the third party about to bind
   * @param {string} profile_key - third-party ticket that preserves information temporaily
   * @return {Promise} switch result
   */
  this.switchBindAuth = function (params) {
    var platform_app_id = params.platform_app_id,
      profile_key = params.profile_key,
      _params$extra_params7 = params.extra_params,
      extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.AUTH_SWITCH_BIND,
        method: 'POST',
        data: _extends({
          platform_app_id: platform_app_id,
          profile_key: profile_key
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} token - 扫tv端获取到的信息，url获取
   */
  this.changeQrcodeSuccess = function (params) {
    var token = params.token,
      _params$extra_params8 = params.extra_params,
      extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    return _this.request({
      url: WEB_URL.CHANGE_QRCODE_SUCCESS,
      method: 'POST',
      data: _extends({
        token: token
      }, extra_params)
    });
  };
  /**
   * @param {string} token - 扫tv端获取到的信息，url获取
   * @param {string} verify_ticket - 验证码正确后返回的票据
   */
  this.changeQrcodeComfirm = function (params) {
    var token = params.token,
      verify_ticket = params.verify_ticket,
      _params$extra_params9 = params.extra_params,
      extra_params = _params$extra_params9 === void 0 ? {} : _params$extra_params9;
    return _this.request({
      url: WEB_URL.CHANGE_QRCODE_CONFIRM,
      method: 'POST',
      data: _extends({
        token: token,
        verify_ticket: verify_ticket
      }, extra_params)
    });
  };
  var request = props.request;
  this.request = request;
};

var ExtraAPI = function ExtraAPI(props) {
  var _this = this;
  /**
   * @param {string} mobile - the mobile to check
   * @return {Promise} check result
   */
  this.checkMobileRegistered = function (params) {
    var mobile = params.mobile,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      mobile: mobile
    }, extra_params), ['mobile']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.CHECK_MOBILE_REGISTER,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email to check
   * @return {Promise} check result
   */
  this.checkEmailRegistered = function (params) {
    var email = params.email,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      email: email
    }, extra_params), ['email']);
    return _this.request({
      url: WEB_URL.CHECK_EMAIL_REGISTER,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} mobile - mobile
   * @param {number} type - send code type
   * @return {Promise} send result
   */
  this.sendCode = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params = params,
      mobile = _params.mobile,
      type = _params.type,
      _params$extra_params3 = _params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3,
      _params$method = _params.method,
      method = _params$method === void 0 ? 'POST' : _params$method;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: type
    }, extra_params), ['mobile', 'type']);
    return _this.request({
      url: WEB_URL.SEND_MOBILE_CODE,
      method: method,
      data: data
    });
  };
  /**
   * @param {string} email - email
   * @param {number} type - send code type
   * @return {Promise} send result
   */
  this.sendEmailCode = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params2 = params,
      email = _params2.email,
      type = _params2.type,
      _params2$extra_params = _params2.extra_params,
      extra_params = _params2$extra_params === void 0 ? {} : _params2$extra_params;
    var data = encryptParams(_extends({
      email: email,
      type: type
    }, extra_params), ['email', 'type']);
    return _this.request({
      url: WEB_URL.SEND_EMAIL_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} code - the captcha
   * @param {number} type - send code type
   * @return {Promise} verify result
   */
  this.validateMobile = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params3 = params,
      code = _params3.code,
      type = _params3.type,
      _params3$extra_params = _params3.extra_params,
      extra_params = _params3$extra_params === void 0 ? {} : _params3$extra_params;
    var data = encryptParams(_extends({
      code: code,
      type: type
    }, extra_params), ['code', 'type']);
    return _this.request({
      url: WEB_URL.VERIFY_MOBILE_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} mobile - mobile to be verified
   * @param {string} code - the captcha
   * @param {number} type - send code type
   * @return {Promise} - verify result
   */
  this.validateCode = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params4 = params,
      mobile = _params4.mobile,
      code = _params4.code,
      type = _params4.type,
      _params4$extra_params = _params4.extra_params,
      extra_params = _params4$extra_params === void 0 ? {} : _params4$extra_params;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      type: type
    }, extra_params), ['mobile', 'code', 'type']);
    return _this.request({
      url: WEB_URL.CHECK_MOBILE_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} email - email to be verified
   * @param {string} code - the captcha
   * @param {number} type - send code type
   * @return {Promise} - verify result
   */
  this.validateEmailCode = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params5 = params,
      email = _params5.email,
      code = _params5.code,
      type = _params5.type,
      _params5$extra_params = _params5.extra_params,
      extra_params = _params5$extra_params === void 0 ? {} : _params5$extra_params;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      type: type
    }, extra_params), ['email', 'code', 'type']);
    return _this.request({
      url: WEB_URL.CHECK_EMAIL_CODE,
      method: 'POST',
      data: data
    });
  };
  var request = props.request;
  this.request = request;
};

// import { encryptParams } from '../../utils/index';
var RegisterAPI$1 = function RegisterAPI(props) {
  var request = props.request;
  this.request = request;
};

var ForgetPwdAPI$1 = function ForgetPwdAPI(props) {
  var _this = this;
  /**
   * @param {string} mobile - the mobile used to verify user's identity
   * @return {Promise} send result
   */
  this.sendCode = function (params) {
    var mobile = params.mobile,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: 6
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - mobile to be verified
   * @param {string} code - the captcha
   * @return {Promise} - verify result
   */
  this.validateCode = function (params) {
    var mobile = params.mobile,
      code = params.code,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      type: 6
    }, extra_params), ['mobile', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.CHECK_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password - the new password
   * @param {string} mobile - the mobile used to verify user's identity
   * @param {string} code - the captcha
   * @return {Promise} reset result
   */
  this.resetPwdByMobile = function (params) {
    var password = params.password,
      mobile = params.mobile,
      code = params.code,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      password: password,
      mobile: mobile,
      code: code
    }, extra_params), ['password', 'mobile', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.RESET_PWD_BY_MOBILE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email used to verify user's identity
   * @return {Promise} send result
   */
  this.sendEmailCode = function (params) {
    var email = params.email,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      email: email,
      type: 4
    }, extra_params), ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - email to be verified
   * @param {string} code - the captcha
   * @return {Promise} - verify result
   */
  this.validateEmail = function (params) {
    var email = params.email,
      code = params.code,
      _params$extra_params5 = params.extra_params,
      extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      type: 4
    }, extra_params), ['email', 'code', 'type']);
    return _this.request({
      url: WEB_URL.CHECK_EMAIL_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} password - the new password
   * @param {string} email - the email used to verify user's identity
   * @param {string} code - the captcha
   * @return {Promise} reset result
   */
  this.resetPwdByEmail = function (params) {
    var password = params.password,
      email = params.email,
      code = params.code,
      _params$extra_params6 = params.extra_params,
      extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    var data = encryptParams(_extends({
      password: password,
      email: email,
      code: code
    }, extra_params), ['password', 'email', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.RESET_PWD_BY_EMAIL,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password - the new password
   * @param {string} ticket - the ticket returned after mobile verification
   * @return {Promise} reset result
   */
  this.resetPwdByMobileTicket = function (params) {
    var password = params.password,
      ticket = params.ticket,
      _params$extra_params7 = params.extra_params,
      extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    var data = encryptParams(_extends({
      password: password,
      ticket: ticket
    }, extra_params), ['password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.RESET_PWD_BY_MOBILE_TICKET,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password - the new password
   * @param {string} ticket - the ticket returned after email verification
   * @return {Promise} reset result
   */
  this.resetPwdByEmailTicket = function (params) {
    var password = params.password,
      ticket = params.ticket,
      _params$extra_params8 = params.extra_params,
      extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    var data = encryptParams(_extends({
      password: password,
      ticket: ticket
    }, extra_params), ['password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.RESET_PWD_BY_EMAIL_TICKET,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password - the new password
   * @param {string} ticket - the ticket returned after mobile verification
   * @param {string} conditional_login_ticket - the ticket by login error
   * @return {Promise} reset result
   */
  this.forceResetPwdByMobileTicket = function (params) {
    var password = params.password,
      ticket = params.ticket,
      conditional_login_ticket = params.conditional_login_ticket,
      code = params.code,
      _params$extra_params9 = params.extra_params,
      extra_params = _params$extra_params9 === void 0 ? {} : _params$extra_params9;
    var data = encryptParams(_extends({
      password: password,
      ticket: ticket,
      conditional_login_ticket: conditional_login_ticket,
      code: code
    }, extra_params), ['password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.FORCE_RESET_PWD_BY_MOBILE_TICKET,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password - the new password
   * @param {string} ticket - the ticket returned after email verification
   * @param {string} conditional_login_ticket - the ticket by login error
   * @return {Promise} reset result
   */
  this.forceResetPwdByEmailTicket = function (params) {
    var password = params.password,
      ticket = params.ticket,
      conditional_login_ticket = params.conditional_login_ticket,
      code = params.code,
      _params$extra_params10 = params.extra_params,
      extra_params = _params$extra_params10 === void 0 ? {} : _params$extra_params10;
    var data = encryptParams(_extends({
      password: password,
      ticket: ticket,
      conditional_login_ticket: conditional_login_ticket,
      code: code
    }, extra_params), ['password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.FORCE_RESET_PWD_BY_EMAIL_TICKET,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  var request = props.request;
  this.request = request;
};

var RebindAPI = function RebindAPI(props) {
  var _this = this;
  /**
   * @param {string} mobile - the mobile about to unbind
   * @param {boolean} use_bind_mobile - true for using the binded mobile, false for using the mobile in the parameters
   * @return {Promise} send result
   */
  this.sendCodeToOldMobile = function (params) {
    var mobile = params.mobile,
      _params$use_bind_mobi = params.use_bind_mobile,
      use_bind_mobile = _params$use_bind_mobi === void 0 ? true : _params$use_bind_mobi,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var type = use_bind_mobile ? 22 : 28;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: type
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} code - the code received by the old mobile
   * @param {boolean} use_bind_mobile - true for using the binded mobile, false for using the mobile in the parameters
   * @return {Promise} verify result
   */
  this.validateOldMobile = function (params) {
    var code = params.code,
      _params$use_bind_mobi2 = params.use_bind_mobile,
      use_bind_mobile = _params$use_bind_mobi2 === void 0 ? true : _params$use_bind_mobi2,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var type = use_bind_mobile ? 22 : 28;
    var data = encryptParams(_extends({
      code: code,
      type: type
    }, extra_params), ['code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.VERIFY_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile about to bind
   * @param {string} old_mobile - the mobile about to unbind
   * @param {string} ticket - the ticket returned from <validateOldMobile>
   * @return {Promise} send result
   */
  this.sendCodeToNewMobile = function (params) {
    var mobile = params.mobile,
      old_mobile = params.old_mobile,
      ticket = params.ticket,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      mobile: mobile,
      old_mobile: old_mobile,
      type: 20,
      ticket: ticket
    }, extra_params), ['mobile', 'old_mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile about to bind
   * @param {string} code - the captcha
   * @param {string} ticket - the ticket returned from <validateOldMobile>
   * @param {number} kick_other - whether kick off the login status of other devices, 0 for no, 1 for yes
   * @return {Promise} bind result
   */
  this.rebindMobile = function (params) {
    var mobile = params.mobile,
      code = params.code,
      ticket = params.ticket,
      _params$kick_other = params.kick_other,
      kick_other = _params$kick_other === void 0 ? 0 : _params$kick_other,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      ticket: ticket,
      kick_other: kick_other
    }, extra_params), ['mobile', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.MOBILE_REBIND,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email about to unbind
   * @return {Promise} send result
   */
  this.sendCodeToOldEmail = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params = params,
      email = _params.email,
      _params$extra_params5 = _params.extra_params,
      extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var data = encryptParams(_extends({
      email: email,
      type: 6
    }, extra_params), ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email about to unbind
   * @param {string} code - the code received by the old mobile
   * @return {Promise} verify result
   */
  this.validateOldEmail = function (params) {
    var email = params.email,
      code = params.code,
      _params$extra_params6 = params.extra_params,
      extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      type: 6
    }, extra_params), ['email', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.VERIFY_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email about to bind
   * @param {string} ticket - the ticket
   * @return {Promise} send result
   */
  this.sendCodeToNewEmail = function (params) {
    var email = params.email,
      ticket = params.ticket,
      _params$extra_params7 = params.extra_params,
      extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    var data = encryptParams(_extends({
      email: email,
      ticket: ticket,
      type: 7
    }, extra_params), ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - the email about to bind
   * @param {string} code - the captcha
   * @param {string} ticket - the ticket returned from <validateOldEmail>
   * @return {Promise} bind result
   */
  this.rebindEmail = function (params) {
    var email = params.email,
      code = params.code,
      ticket = params.ticket,
      _params$extra_params8 = params.extra_params,
      extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      type: 7,
      ticket: ticket
    }, extra_params), ['email', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.EMAIL_REBIND,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  var request = props.request;
  this.request = request;
};

var PasswordAPI = function PasswordAPI(props) {
  var _this = this;
  /**
   * @param {boolean} verify_mobile_seperate - whether to verify the mobile captcha seperately
   * @return {Promise} send result
   */
  this.sendCode = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params = params,
      _params$verify_mobile = _params.verify_mobile_seperate,
      verify_mobile_seperate = _params$verify_mobile === void 0 ? false : _params$verify_mobile,
      _params$extra_params = _params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var type = verify_mobile_seperate ? 22 : 13;
    var data = encryptParams(_extends({
      type: type
    }, extra_params), ['type']);
    return _this.request({
      url: WEB_URL.SEND_MOBILE_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} code - the captcha
   * @return {Promise} verify result
   */
  this.validateMobile = function (params) {
    var code = params.code,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      code: code,
      type: 22
    }, extra_params), ['code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.VERIFY_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password - new password
   * @param {string} code - the captcha
   * @param {string} ticket - the ticket returned after mobile verification
   * @return {Promise} change result
   */
  this.changePwdByMobile = function (params) {
    var password = params.password,
      code = params.code,
      ticket = params.ticket,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      password: password,
      code: code,
      ticket: ticket
    }, extra_params), ['password', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.PWD_CHANGE_BY_MOBILE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password - new password
   * @param {string} current_password - old password
   * @return {Promise} update result
   */
  this.updatePwd = function (params) {
    var password = params.password,
      current_password = params.current_password,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      password: password,
      current_password: current_password
    }, extra_params), ['password', 'current_password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.PWD_UPDATE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @return {Promise} send result
   */
  this.sendEmailCode = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params2 = params,
      _params2$extra_params = _params2.extra_params,
      extra_params = _params2$extra_params === void 0 ? {} : _params2$extra_params;
    var data = encryptParams(_extends({
      type: 11
    }, extra_params), ['type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} code - the captcha
   * @return {Promise} verify result
   */
  this.validateEmail = function (params) {
    var code = params.code,
      _params$extra_params5 = params.extra_params,
      extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var data = encryptParams(_extends({
      code: code,
      type: 11
    }, extra_params), ['code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.VERIFY_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password - new password
   * @param {string} code - the captcha
   * @param {string} ticket - the ticket returned after email verification
   * @return {Promise} change result
   */
  this.changePwdByEmail = function (params) {
    var password = params.password,
      code = params.code,
      ticket = params.ticket,
      _params$extra_params6 = params.extra_params,
      extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    var data = encryptParams(_extends({
      password: password,
      code: code,
      ticket: ticket
    }, extra_params), ['password', 'code']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.PWD_CHANGE_BY_EMAIL,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} password
   * @return {Promise} set result
   */
  this.setPassword = function (params) {
    var password = params.password,
      _params$extra_params7 = params.extra_params,
      extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    var data = encryptParams(_extends({
      password: password
    }, extra_params), ['password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.PWD_SET,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @return {Promise} check result
   */
  this.checkHasSetPwd = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params3 = params,
      _params3$extra_params = _params3.extra_params,
      extra_params = _params3$extra_params === void 0 ? {} : _params3$extra_params;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.PWD_HAS_SET,
        method: 'POST',
        data: extra_params
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @return {Promise} check result
   */
  this.checkWebHasSetPwd = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params4 = params,
      _params4$extra_params = _params4.extra_params,
      extra_params = _params4$extra_params === void 0 ? {} : _params4$extra_params;
    return _this.request({
      url: WEB_URL.PWD_HAS_SET_V2,
      method: 'GET',
      data: extra_params
    });
  };
  /**
   * @param {string} password
   * @param {string} email
   * @param {string} code
   * @return {Promise} check result
   */
  this.resetPwdLoginByEmail = function (params) {
    var password = params.password,
      email = params.email,
      code = params.code,
      _params$extra_params8 = params.extra_params,
      extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    var data = encryptParams(_extends({
      password: password,
      email: email,
      code: code
    }, extra_params), ['password', 'email', 'code']);
    return _this.request({
      url: WEB_URL.PWD_RESET_LOGIN_BY_EMAIL,
      method: 'GET',
      data: data
    });
  };
  /*
   * @param {string} password - new password
   * @param {string} code - the email verification code
   * @param {string} email - the verified email
   * @return {Promise} change result
   */
  this.changePwdByEmailAndLogin = function (params) {
    var password = params.password,
      code = params.code,
      email = params.email,
      _params$extra_params9 = params.extra_params,
      extra_params = _params$extra_params9 === void 0 ? {} : _params$extra_params9;
    var data = encryptParams(_extends({
      password: password,
      code: code,
      email: email
    }, extra_params), ['password', 'code']);
    return _this.request({
      url: WEB_URL.PWD_SET_BY_EAMIL_AND_LOGIN,
      method: 'POST',
      data: data
    });
  };
  var request = props.request;
  this.request = request;
};

var VerifyAPI = function VerifyAPI(props) {
  var _this = this;
  /**
   * @param {string} mobile - mobile to be verified
   * @return {Promise} - send result
   */
  this.notLoginSendCode = function (params) {
    var mobile = params.mobile,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: 34
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - mobile to be verified
   * @param {string} code - the captcha
   * @return {Promise} - verify result
   */
  this.notLoginValidateMobile = function (params) {
    var mobile = params.mobile,
      code = params.code,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      type: 34
    }, extra_params), ['mobile', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.CHECK_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - email to be verified
   * @return {Promise} - send result
   */
  this.notLoginSendEmailCode = function (params) {
    var email = params.email,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      email: email,
      type: 15
    }, extra_params), ['email', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} email - email to be verified
   * @param {string} code - the captcha
   * @return {Promise} - verify result
   */
  this.notLoginValidateEmail = function (params) {
    var email = params.email,
      code = params.code,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      email: email,
      code: code,
      type: 15
    }, extra_params), ['email', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.CHECK_EMAIL_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @return {Promise} - send result
   */
  this.sendCode = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params = params,
      _params$extra_params5 = _params.extra_params,
      extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var data = encryptParams(_extends({
      type: 22
    }, extra_params), ['type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} code - the captcha
   * @return {Promise} - verify result
   */
  this.validateMobile = function (params) {
    var code = params.code,
      _params$extra_params6 = params.extra_params,
      extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    var data = encryptParams(_extends({
      code: code,
      type: 22
    }, extra_params), ['code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.VERIFY_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @return {Promise} - send result
   */
  this.sendEmailCode = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params2 = params,
      _params2$extra_params = _params2.extra_params,
      extra_params = _params2$extra_params === void 0 ? {} : _params2$extra_params;
    var data = encryptParams(_extends({
      type: 6
    }, extra_params), ['type']);
    return _this.request({
      url: WEB_URL.SEND_EMAIL_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} code - the captcha
   * @return {Promise} - verify result
   */
  this.validateEmail = function (params) {
    var code = params.code,
      _params$extra_params7 = params.extra_params,
      extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    var data = encryptParams(_extends({
      code: code,
      type: 6
    }, extra_params), ['code', 'type']);
    return _this.request({
      url: WEB_URL.VERIFY_EMAIL_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} account - account to be verified, mobile / email / username
   * @param {string} password - corresponding password
   * @return {Promise} - verify result
   */
  this.accountVerify = function (params) {
    var account = params.account,
      password = params.password,
      _params$extra_params8 = params.extra_params,
      extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    var data = encryptParams(_extends({
      account: account,
      password: password,
      user_login_version: 1
    }, extra_params), ['account', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.ACCOUNT_VERIFY,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {number} platform_app_id - the app id of the third party used to login
   * @param {string} code - authorization code
   * @param {string} access_token - third-party authorization token
   * @param {string} access_token_secret - id token, only neccessary when using google to login
   * @param {string} openid - third-party openid, used with access_token
   * @param {string} profile_key - third-party ticket that preserves information temporaily, used when the login progress is blocked
   * @return {Promise} login result
   */
  this.authVerify = function (params) {
    var platform_app_id = params.platform_app_id,
      code = params.code,
      access_token = params.access_token,
      access_token_secret = params.access_token_secret,
      openid = params.openid,
      profile_key = params.profile_key,
      _params$extra_params9 = params.extra_params,
      extra_params = _params$extra_params9 === void 0 ? {} : _params$extra_params9;
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.AUTH_VERIFY,
        method: 'POST',
        data: _extends({
          platform_app_id: platform_app_id,
          code: code,
          access_token: access_token,
          access_token_secret: access_token_secret,
          openid: openid,
          profile_key: profile_key
        }, extra_params)
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile used to authorize
   * @return {Promise} send result
   */
  this.smsAuthorizeSendCode = function (params) {
    var mobile = params.mobile,
      _params$extra_params10 = params.extra_params,
      extra_params = _params$extra_params10 === void 0 ? {} : _params$extra_params10;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: 26
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} mobile - the mobile used to authorize
   * @param {string} code - the code
   * @return {Promise} send result
   */
  this.smsAuthorize = function (params) {
    var mobile = params.mobile,
      code = params.code,
      _params$extra_params11 = params.extra_params,
      extra_params = _params$extra_params11 === void 0 ? {} : _params$extra_params11;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      type: 26
    }, extra_params), ['mobile', 'code', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_URL.SMS_AUTHORIZE,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * @param {string} need_limit_platform
   * @param {string} not_login_ticket
   * @param {string} ticket
   * @return {Promise} request result
   */
  this.getAvailableWays = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params3 = params,
      _params3$need_limit_p = _params3.need_limit_platform,
      need_limit_platform = _params3$need_limit_p === void 0 ? 0 : _params3$need_limit_p,
      not_login_ticket = _params3.not_login_ticket,
      ticket = _params3.ticket,
      _params3$extra_params = _params3.extra_params,
      extra_params = _params3$extra_params === void 0 ? {} : _params3$extra_params;
    return _this.request({
      url: WEB_URL.AVAILABLE_WAYS,
      method: 'POST',
      data: _extends({
        need_limit_platform: need_limit_platform,
        not_login_ticket: not_login_ticket,
        ticket: ticket
      }, extra_params)
    });
  };
  /**
   * @param {string} username
   * @param {string} mobile
   * @param {string} email
   * @param {string} password
   * @param {string} verify_ticket
   * @return {Promise} verify result
   */
  this.verifyPwdWithoutLogin = function (params) {
    var username = params.username,
      mobile = params.mobile,
      email = params.email,
      password = params.password,
      verify_ticket = params.verify_ticket,
      _params$extra_params12 = params.extra_params,
      extra_params = _params$extra_params12 === void 0 ? {} : _params$extra_params12;
    var data = encryptParams(_extends({
      username: username,
      mobile: mobile,
      email: email,
      password: password,
      verify_ticket: verify_ticket
    }, extra_params), ['username', 'mobile', 'email', 'password']);
    return _this.request({
      url: WEB_URL.VERIFY_PWD_WITHOUT_LOGIN,
      method: 'POST',
      data: data
    });
  };
  var request = props.request;
  this.request = request;
};

var CancelAPI = function CancelAPI(props) {
  var _this = this;
  /**
   * @param {string} cancel_ticket - Ticket returned by cancel_check API
   * @return {Promise} - result
   */
  this.verifyWay = function (params) {
    var cancel_ticket = params.cancel_ticket,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    return _this.request({
      url: WEB_URL.CANCEL_VERIFY_WAY,
      method: 'GET',
      data: _extends({
        cancel_ticket: cancel_ticket
      }, extra_params)
    });
  };
  /**
   * @param {string} value_ticket - A ticket representing the value of the user
   * @return {Promise} - result
   */
  this.checkIfPass = function (params) {
    var value_ticket = params.value_ticket,
      extra_params = params.extra_params;
    return _this.request({
      url: WEB_URL.CANCEL_CHECK,
      method: 'GET',
      data: _extends({
        value_ticket: value_ticket
      }, extra_params)
    });
  };
  /**
   * @param {string} value_ticket - A ticket representing the value of the user
   * @param {string} token - A ticket obtained after verification such as mobile phone number verification code
   * @param {string} cancel_ticket - Ticket returned by cancel_check API
   * @param {string} abandon - A comma-separated string containing abandoned assets
   * @return {Promise} - result
   */
  this.confirm = function (params) {
    var value_ticket = params.value_ticket,
      token = params.token,
      cancel_ticket = params.cancel_ticket,
      abandon = params.abandon,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    return _this.request({
      url: WEB_URL.CANCEL_CONFIRM,
      method: 'POST',
      data: _extends({
        value_ticket: value_ticket,
        token: token,
        cancel_ticket: cancel_ticket,
        abandon: abandon
      }, extra_params)
    });
  };
  /**
   * @param {string} id_uri1
   * @param {string} id_uri2
   * @param {string} apply_uri
   * @param {string} ticket
   * @return {Promise} - result
   */
  this.cancelRequest = function (params) {
    var id_uri1 = params.id_uri1,
      id_uri2 = params.id_uri2,
      apply_uri = params.apply_uri,
      ticket = params.ticket,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    return _this.request({
      url: WEB_URL.CANCEL_REQUEST,
      method: 'POST',
      data: _extends({
        id_uri1: id_uri1,
        id_uri2: id_uri2,
        apply_uri: apply_uri,
        ticket: ticket
      }, extra_params)
    });
  };
  /**
   * @param {number} type
   * @param {string} token
   * @return {Promise} - result
   */
  this.cancelLogin = function (params) {
    var type = params.type,
      token = params.token,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    return _this.request({
      url: WEB_URL.CANCEL_LOGIN,
      method: 'POST',
      data: _extends({
        type: type,
        token: token
      }, extra_params)
    });
  };
  var request = props.request;
  this.request = request;
};

var _excluded$8 = ["extra_params"],
  _excluded2$4 = ["extra_params"];
var OpenAPI = /*#__PURE__*/function () {
  function OpenAPI(props) {
    var request = props.request;
    this.request = request;
  }
  /**
   * [get auth info]
   * @param {string} client_key key of third-party app
   * @param {string} scope list of authorities
   * @return {Promise} request result
   */
  var _proto = OpenAPI.prototype;
  _proto.getAuthInfo = function getAuthInfo(params) {
    var client_key = params.client_key,
      scope = params.scope,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    return this.request({
      url: WEB_URL.GET_OPEN_AUTH_INFO,
      method: 'GET',
      data: _extends({
        client_key: client_key,
        scope: scope
      }, extra_params)
    });
  }
  /**
   * [send code]
   * @param {string} mobile - the mobile used to login
   * @return {Promise} send result
   */;
  _proto.sendCode = function sendCode(params) {
    var mobile = params.mobile,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: 27
    }, extra_params), ['mobile', 'type']);
    return this.request({
      url: WEB_URL.OPEN_SEND_CODE,
      method: 'GET',
      data: data
    });
  }
  /**
   * [sms authorization]
   * @param {string} client_key key of third-party app
   * @param {string} scope list of authorities
   * @param {string} source source of authorization
   * @param {string} redirect_uri redirect url after successful authorization
   * @param {string} state security check
   * @param {string} mobile mobile used to authorize
   * @param {string} code corresponding sms code
   * @return {Promise} auth result
   */;
  _proto.smsAuth = function smsAuth(params) {
    var client_key = params.client_key,
      scope = params.scope,
      source = params.source,
      redirect_uri = params.redirect_uri,
      state = params.state,
      mobile = params.mobile,
      code = params.code,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    var data = encryptParams(_extends({
      client_key: client_key,
      scope: scope,
      source: source,
      redirect_uri: redirect_uri,
      state: state,
      mobile: mobile,
      code: code
    }, extra_params), ['mobile', 'code']);
    return this.request({
      url: WEB_URL.OPEN_SMS_AUTH,
      method: 'POST',
      data: data
    });
  }
  /**
   * [account authorization]
   * @param {string} client_key key of third-party app
   * @param {string} scope list of authorities
   * @param {string} source source of authorization
   * @param {string} redirect_uri redirect url after successful authorization
   * @param {string} state security check
   * @param {string} account account used to authorize
   * @param {string} password corresponding password
   * @return {Promise} auth result
   */;
  _proto.accountAuth = function accountAuth(params) {
    var client_key = params.client_key,
      scope = params.scope,
      source = params.source,
      redirect_uri = params.redirect_uri,
      state = params.state,
      password = params.password,
      account = params.account,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var data = encryptParams(_extends({
      client_key: client_key,
      scope: scope,
      source: source,
      redirect_uri: redirect_uri,
      state: state,
      password: password,
      account: account
    }, extra_params), ['password', 'account']);
    return this.request({
      url: WEB_URL.OPEN_ACCOUNT_AUTH,
      method: 'POST',
      data: data
    });
  }
  /**
   * [third-party oauth authorization]
   * @param {string} client_key key of third-party app
   * @param {string} scope list of authorities
   * @param {string} source source of authorization
   * @param {string} redirect_uri redirect url after successful authorization
   * @param {string} state security check
   * @param {number} platform_app_id the third appId
   * @param {string} access_token token of third-party authorization
   * @param {string} access_token_secret token of google authorization
   * @param {string} code code of third-party authorization
   * @param {number} expires_in expire time
   * @param {number} openid openid of third platform
   * @param {string} profile_key - third-party ticket that preserves information temporaily
   * @param {string} platform - the platform used to authorize
   * @return {Promise} auth result
   */;
  _proto.thirdAuth = function thirdAuth(params) {
    var _params$extra_params5 = params.extra_params,
      extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5,
      normalParams = _objectWithoutPropertiesLoose(params, _excluded$8);
    return this.request({
      url: WEB_URL.OPEN_THIRD_AUTH,
      method: 'POST',
      data: _extends({}, normalParams, extra_params)
    });
  }
  /**
   * [open get qrcode]
   * @param {string} client_key key of third-party app
   * @param {string} scope list of authorities
   * @param {string} state security check
   * @param {string} next callback address of third-party app
   * @returns {Promise} get result
   */;
  _proto.getQRCode = function getQRCode(params) {
    var client_key = params.client_key,
      scope = params.scope,
      state = params.state,
      next = params.next,
      _params$extra_params6 = params.extra_params,
      extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    return this.request({
      url: WEB_URL.OPEN_GET_QRCODE,
      method: 'POST',
      data: _extends({
        client_key: client_key,
        scope: scope,
        state: state,
        next: next
      }, extra_params)
    });
  }
  /**
   * [check the state of qrcode]
   * @param {string} token identifier of qrcode
   * @param {string} next callback address of third-party app
   * @param {string} scope list of authorities
   * @param {string} client_key key of third -party app
   * @returns {Promise} request result
   */;
  _proto.checkQRCode = function checkQRCode(params) {
    var token = params.token,
      next = params.next,
      scope = params.scope,
      client_key = params.client_key,
      _params$extra_params7 = params.extra_params,
      extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    return this.request({
      url: WEB_URL.OPEN_CHECK_QRCODE,
      method: 'POST',
      data: _extends({
        token: token,
        next: next,
        scope: scope,
        client_key: client_key
      }, extra_params)
    });
  }
  /**
   * [request the authorization page]
   * @returns {Promise} request result
   */;
  _proto.toScanQRCode = function toScanQRCode(params) {
    var _params$extra_params8 = params.extra_params,
      extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    return this.request({
      url: WEB_URL.OPEN_TO_SCAN_QRCODE,
      method: 'POST',
      data: _extends({}, extra_params)
    });
  }
  /**
   * [change state of the qrcode]
   * @param {string} token identifier of qrcode
   * @returns {Promise} request result
   */;
  _proto.scanQRCode = function scanQRCode(params) {
    var token = params.token,
      _params$extra_params9 = params.extra_params,
      extra_params = _params$extra_params9 === void 0 ? {} : _params$extra_params9;
    return this.request({
      url: WEB_URL.OPEN_SCAN_QRCODE,
      method: 'POST',
      data: _extends({
        token: token
      }, extra_params)
    });
  }
  /**
   * [user confirm to give authorization]
   * @param {string} token identifier of qrcode
   * @param {string} scopes list of authorities
   * @returns {Promise} confirm result
   */;
  _proto.confirmQRCode = function confirmQRCode(params) {
    var token = params.token,
      scopes = params.scopes,
      _params$extra_params10 = params.extra_params,
      extra_params = _params$extra_params10 === void 0 ? {} : _params$extra_params10;
    return this.request({
      url: WEB_URL.OPEN_CONFIRM_QRCODE,
      method: 'POST',
      data: _extends({
        token: token,
        scopes: scopes
      }, extra_params)
    });
  }
  /**
   * [third-party oauth authorization]
   * @param {string} client_key key of third-party app
   * @param {string} scope list of authorities
   * @param {string} source source of authorization
   * @param {string} redirect_uri redirect url after successful authorization
   * @param {string} state security check
   * @param {string} device_platform device platform
   * @param {string} extra_info
   * @param {string} skip_confirm
   * @return {Promise} auth result
   */;
  _proto.webAuth = function webAuth(params) {
    var _params$extra_params11 = params.extra_params,
      extra_params = _params$extra_params11 === void 0 ? {} : _params$extra_params11,
      normalParams = _objectWithoutPropertiesLoose(params, _excluded2$4);
    return this.request({
      url: WEB_URL.OPEN_WEB_AUTH,
      method: 'POST',
      data: _extends({}, normalParams, extra_params)
    });
  };
  return OpenAPI;
}();

var AccountAPI = function AccountAPI(props) {
  var _this = this;
  /**
   * @return {Promise} request result
   */
  this.getAccountInfo = function (params) {
    if (params === void 0) {
      params = {};
    }
    var _params = params,
      _params$extra_params = _params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    return _this.request({
      url: WEB_URL.ACCOUNT_INFO,
      method: 'GET',
      data: extra_params
    });
  };
  /**
   * @param {string} password - password
   * @param {string} username - username
   * @return {Promise} set result
   */
  this.setAccount = function (params) {
    var _ref = params || {},
      password = _ref.password,
      username = _ref.username,
      _ref$extra_params = _ref.extra_params,
      extra_params = _ref$extra_params === void 0 ? {} : _ref$extra_params;
    var data = encryptParams(_extends({
      password: password,
      username: username
    }, extra_params), ['password', 'username']);
    return _this.request({
      url: WEB_URL.ACCOUNT_SET,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} login_name - login name
   * @return {Promise} register result
   */
  this.registerLoginName = function (params) {
    var login_name = params.login_name,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    return _this.request({
      url: WEB_URL.ACCOUNT_REGISTER_LOGIN_NAME,
      method: 'POST',
      data: _extends({
        login_name: login_name
      }, extra_params)
    });
  };
  /**
   * @param {number} platform_app_id
   * @param {string} next
   * @param {string} action
   * @return {Promise} request result
   */
  this.authConfig = function (params) {
    var platform_app_id = params.platform_app_id,
      next = params.next,
      action = params.action,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    return _this.request({
      url: WEB_URL.ACCOUNT_AUTH_CONFIG,
      method: 'POST',
      data: _extends({
        platform_app_id: platform_app_id,
        next: next,
        action: action
      }, extra_params)
    });
  };
  /**
   * @param {string} login_name - login name
   * @return {Promise} register result
   */
  this.updateLoginName = function (params) {
    var login_name = params.login_name,
      _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    return _this.request({
      url: WEB_URL.ACCOUNT_UPDATE_LOGIN_NAME,
      method: 'POST',
      data: _extends({
        login_name: login_name
      }, extra_params)
    });
  };
  var request = props.request;
  this.request = request;
};

var _excluded$9 = ["extra_params"];
var UserAPI$1 = function UserAPI(props) {
  var _this = this;
  /**
   * @param {string} access_token - the third platform token
   * @param {string} access_token_secret - the google platform secret token
   * @param {string} code - the third platform code
   * @param {number} expires_in - the token expire time
   * @param {string} openid - the third platform openid
   * @param {string} platform - the third platform name
   * @param {number} platform_app_id - the third platform app_id
   * @return {Promise} Oauth Profile result
   */
  this.getOauthProfile = function (params) {
    var _this$props;
    var access_token = params.access_token,
      access_token_secret = params.access_token_secret,
      code = params.code,
      expires_in = params.expires_in,
      openid = params.openid,
      platform_app_id = params.platform_app_id,
      platform = params.platform,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    return _this.request({
      url: WEB_URL.OAUTH_PROFILE,
      method: 'GET',
      data: _extends({
        aid: (_this$props = _this.props) === null || _this$props === void 0 ? void 0 : _this$props.aid,
        access_token: access_token,
        access_token_secret: access_token_secret,
        code: code,
        expires_in: expires_in,
        openid: openid,
        platform_app_id: platform_app_id,
        platform: platform
      }, extra_params)
    });
  };
  /**
   * @param {File} avatar - the user avatar to upload
   * @return {Promise} upload result
   */
  this.uploadAvatar = function (params) {
    var avatar = params.avatar,
      extra_params = params.extra_params;
    var data = new FormData();
    var blob = new Blob([avatar], {
      type: avatar.type
    });
    data.append('avatar', blob);
    var url = WEB_URL.UPLOAD_AVATAR;
    return _this.request({
      url: url,
      method: 'POST',
      data: data,
      params: _extends({}, extra_params),
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };
  /**
   * @param {string} avatar - the user avatar
   * @param {string} name - the user name
   * @param {string} description - the user short desc
   * @param {string} area - the user area
   * @param {string} gender - the user gender
   * @param {string} birthday - the user birthday
   * @param {string} expend_attrs - the business custom params
   * @return {Promise} login result
   */
  this.updateUserInfo = function (params) {
    var _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2,
      otherParams = _objectWithoutPropertiesLoose(params, _excluded$9);
    var data = _extends({}, otherParams, extra_params);
    return _this.request({
      url: WEB_URL.UPDATE_USERINFO,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} scene - the business scene
   * @return {Promise} check result
   */
  this.checkDefaultInfo = function (params) {
    var scene = params.scene,
      _params$extra_params3 = params.extra_params,
      extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
    return _this.request({
      url: WEB_URL.CHECK_DEFAULT_INFO,
      method: 'GET',
      params: _extends({
        scene: scene
      }, extra_params)
    });
  };
  /**
   * @return {Promise} get result
   */
  this.getDefaultImageList = function (params) {
    var aid = _this.props.aid;
    var _params$extra_params4 = params.extra_params,
      extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
    var url = WEB_URL.GET_BACKGROUND_LIST.replace('{aid}', String(aid));
    return _this.request({
      url: url,
      method: 'GET',
      params: _extends({}, extra_params)
    });
  };
  /**
   * @return {Promise} get avatar list result
   */
  this.getDefaultAvatarList = function (params) {
    var aid = _this.props.aid;
    var _params$extra_params5 = params.extra_params,
      extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
    var url = WEB_URL.GET_DEFAULT_AVATAR_LIST.replace('{aid}', String(aid));
    return _this.request({
      url: url,
      method: 'GET',
      params: _extends({}, extra_params)
    });
  };
  /**
   * @return {Promise} get recommend name result
   */
  this.getRecommendName = function (params) {
    var _params$extra_params6 = params.extra_params,
      extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
    return _this.request({
      url: WEB_URL.GET_RECOMMEND_NAME,
      method: 'GET',
      params: _extends({}, extra_params)
    });
  };
  /**
   * @param {string} field - the check key
   * @param {string} field_namespace - shark object
   * @return {Promise} check result
   */
  this.checkRemainTimes = function (params) {
    var field = params.field,
      _params$field_namespa = params.field_namespace,
      field_namespace = _params$field_namespa === void 0 ? '' : _params$field_namespa,
      _params$extra_params7 = params.extra_params,
      extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
    return _this.request({
      url: WEB_URL.CHECK_REMAIN_TIMES,
      method: 'GET',
      params: _extends({
        field: field,
        field_namespace: field_namespace
      }, extra_params)
    });
  };
  /**
   * @param {string} pic - the image file
   * @param {boolean} is_sensitive - is sensitive
   * @return {Promise} result res: { message: ""; data: { web_uri : '' } }
   */
  this.uploadPicture = function (params) {
    var pic = params.pic,
      is_sensitive = params.is_sensitive,
      _params$extra_params8 = params.extra_params,
      extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8;
    var data = new FormData();
    var blob = new Blob([pic], {
      type: pic.type
    });
    data.append('pic', blob);
    return _this.request({
      url: WEB_URL.UPLOAD_PICTURE,
      method: 'POST',
      data: data,
      params: _extends({
        is_sensitive: is_sensitive
      }, extra_params)
    });
  };
  /**
   * @param {string} key - the image key
   * @return {Promise} login result
   */
  this.downloadImage = function (params) {
    var key = params.key,
      _params$extra_params9 = params.extra_params,
      extra_params = _params$extra_params9 === void 0 ? {} : _params$extra_params9;
    return _this.request({
      url: WEB_URL.DOWNLOAD_IMAGE,
      method: 'GET',
      params: _extends({
        key: key
      }, extra_params)
    });
  };
  var request = props.request;
  this.request = request;
  this.props = props;
};

var WebInterface = /*#__PURE__*/function (_BaseInterface) {
  _inheritsLoose(WebInterface, _BaseInterface);
  function WebInterface(props) {
    var _this;
    _this = _BaseInterface.call(this, props, 'web') || this;
    var _props$printLog = props.printLog,
      printLog = _props$printLog === void 0 ? false : _props$printLog,
      _props$acrawler = props.acrawler,
      acrawler = _props$acrawler === void 0 ? '' : _props$acrawler;
    // log
    if (printLog) {
      console.log('%cWebInterface Initial Props >>>>%O', 'background: #222; color: #bada55', props);
    }
    // acrawler
    if (acrawler) {
      initAcrawler(acrawler, props);
    }
    // web interfaces
    var argus = _extends({}, props, {
      request: _this.request
    });
    _this.login = new LoginAPI$1(argus);
    _this.qrcodeLogin = new QrCodeLoginAPI(argus);
    _this.register = new RegisterAPI$1(argus);
    _this.forgetPwd = new ForgetPwdAPI$1(argus);
    _this.bind = new BindAPI(argus);
    _this.rebind = new RebindAPI(argus);
    _this.password = new PasswordAPI(argus);
    _this.extra = new ExtraAPI(argus);
    _this.verify = new VerifyAPI(argus);
    _this.cancel = new CancelAPI(argus);
    _this.open = new OpenAPI(argus);
    _this.account = new AccountAPI(argus);
    _this.user = new UserAPI$1(argus);
    // web aff interfaces
    _this.affLogin = new LoginAPI(argus);
    _this.affRegister = new RegisterAPI(argus);
    _this.affInvite = new InviteAPI(argus);
    _this.affSubject = new SubjectAPI(argus);
    _this.affForgetPwd = new ForgetPwdAPI(argus);
    _this.affResource = new ResourceAPI(argus);
    _this.affRole = new RoleAPI(argus);
    _this.affUser = new UserAPI(argus);
    _this.affSuper = new SuperAPI(argus);
    return _this;
  }
  return WebInterface;
}(BaseInterface);

var VerifyAPI$1 = function VerifyAPI(props) {
  var _this = this;
  /**
   * @param {string} mobile - mobile to be verified
   * @return {Promise} - send result
   */
  this.notLoginSendCode = function (params) {
    var mobile = params.mobile,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      mobile: mobile,
      type: 34
    }, extra_params), ['mobile', 'type']);
    return _this.request({
      url: APP_URL.SEND_MOBILE_CODE,
      method: 'POST',
      data: data
    });
  };
  /**
   * @param {string} mobile - mobile to be verified
   * @param {string} code - the captcha
   * @return {Promise} - verify result
   */
  this.notLoginValidateMobile = function (params) {
    var mobile = params.mobile,
      code = params.code,
      _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      type: 34
    }, extra_params), ['mobile', 'code', 'type']);
    return _this.request({
      url: APP_URL.CHECK_MOBILE_CODE,
      method: 'POST',
      data: data
    });
  };
  var request = props.request;
  this.request = request;
};

var _excluded$a = ["extra_params"],
  _excluded2$5 = ["extra_params"];
var LoginAPI$2 = function LoginAPI(props) {
  var _this = this;
  /**
   * @param {string} code - user code returned by open service
   * @param {string} profile_key - user code returned by other process
   * @param {number} platform_app_id - apply for configuration in appcloud
   * @param {string} platform - third-party name
   * @param {number} need_mobile - whether synchronize the mobile of third-party account
   * @param {number} check_mobile - whether restrict old user to bind mobile forcely
   * @param {number} change_bind - whether rebind forcely when conflict occurs
   * @return {Promise} login result
   */
  this.bindWithMobileLogin = function (params) {
    var _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params,
      props = _objectWithoutPropertiesLoose(params, _excluded$a);
    return _this.request({
      url: APP_URL.BIND_WITH_MOBILE_LOGIN,
      method: 'POST',
      data: _extends({}, extra_params, props)
    });
  };
  /**
   * @param {number} platform_app_id - the app id of the third party used to login
   * @param {string} platform - third-party name
   * @param {string} code - authorization code
   * @param {string} access_token - third-party authorization token
   * @param {string} access_token_secret - id token, only neccessary when using google to login
   * @param {string} openid - third-party openid, used with access_token
   * @param {string} profile_key - third-party ticket that preserves information temporaily, used when the login progress is blocked
   * @param {boolean} login_only - whether to login only, not allowing to register
   * @return {Promise} login result
   */
  this.authLogin = function (params) {
    var _params$extra_params2 = params.extra_params,
      extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2,
      props = _objectWithoutPropertiesLoose(params, _excluded2$5);
    return _this.request({
      url: APP_URL.AUTH_LOGIN,
      method: 'POST',
      data: _extends({}, extra_params, props)
    });
  };
  /**
   * [Industry account user switching mobile]
   * @param {string} Industry account system userIdentityId
   */
  this.memberSwitch = function (params) {
    var to_sec_member_id = params.to_sec_member_id;
    return _this.request({
      url: MOBILE_AFF_URL.MEMBER_SWITCH,
      method: 'POST',
      data: {
        to_sec_member_id: to_sec_member_id
      }
    });
  };
  var request = props.request;
  this.request = request;
};

var BindAPI$1 = function BindAPI(props) {
  var _this = this;
  this.unbindUnusableMobile = function (params) {
    var mobile = params.mobile,
      code = params.code,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    var data = encryptParams(_extends({
      mobile: mobile,
      code: code,
      scene: 1
    }, extra_params), ['mobile', 'code']);
    return _this.request({
      url: APP_URL.UNBIND_UNUSABLE_MOBILE,
      method: 'POST',
      data: data
    });
  };
  var request = props.request;
  this.request = request;
};

var AppInterface = /*#__PURE__*/function (_BaseInterface) {
  _inheritsLoose(AppInterface, _BaseInterface);
  function AppInterface(props) {
    var _this;
    _this = _BaseInterface.call(this, props, 'app') || this;
    var _props$printLog = props.printLog,
      printLog = _props$printLog === void 0 ? false : _props$printLog,
      _props$acrawler = props.acrawler,
      acrawler = _props$acrawler === void 0 ? '' : _props$acrawler;
    // log
    if (printLog) {
      console.log('AppInterface Initial Props >>>>', props);
    }
    // acrawler
    if (acrawler) {
      initAcrawler(acrawler, props);
    }
    // web interfaces
    var argus = _extends({}, props, {
      request: _this.request
    });
    _this.verify = new VerifyAPI$1(argus);
    _this.login = new LoginAPI$2(argus);
    _this.bind = new BindAPI$1(argus);
    return _this;
  }
  return AppInterface;
}(BaseInterface);

var _excluded$b = ["mobile", "type"],
  _excluded2$6 = ["mobile", "type"],
  _excluded3$2 = ["email", "password"],
  _excluded4 = ["email", "password"],
  _excluded5 = ["email", "password"],
  _excluded6 = ["email", "password"];
var CommonService = function CommonService(props) {
  var _this = this;
  /**
   * [get mobile verification code] out-of-date
   * @param {string} mobile the mobile used to login
   * @param {number} type codeType
   * @return {Promise} send result
   */
  this.baseSendMobileCode = function (params) {
    var mobile = params.mobile,
      type = params.type,
      extra_params = _objectWithoutPropertiesLoose(params, _excluded$b);
    var data = encryptParams(_extends({
      mobile: mobile,
      type: type
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_SSO.MOBILE_CODE_URL,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * [get mobile verification code V2]
   * @param {string} mobile the mobile used to login
   * @param {number} type codeType
   * @return {Promise} send result
   */
  this.baseSendMobileCodeV2 = function (params) {
    var mobile = params.mobile,
      type = params.type,
      extra_params = _objectWithoutPropertiesLoose(params, _excluded2$6);
    var data = encryptParams(_extends({
      mobile: mobile,
      type: type
    }, extra_params), ['mobile', 'type']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_SSO.MOBILE_CODE_URL_V2,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * [send a verification url to email] out-of-date
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  this.baseSendEmailLink = function (params) {
    var email = params.email,
      password = params.password,
      extra_params = _objectWithoutPropertiesLoose(params, _excluded3$2);
    var data = encryptParams(_extends({
      email: email,
      password: password
    }, extra_params), ['email', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_SSO.EMAIL_ACTIVATE_URL,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * [send a verification link to email v2]
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  this.baseSendEmailLinkV2 = function (params) {
    var email = params.email,
      password = params.password,
      extra_params = _objectWithoutPropertiesLoose(params, _excluded4);
    var data = encryptParams(_extends({
      email: email,
      password: password
    }, extra_params), ['email', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_SSO.EMAIL_ACTIVATE_URL_V2,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * [send a verification code to email] out-of-date
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  this.baseSendEmailCode = function (params) {
    var email = params.email,
      password = params.password,
      extra_params = _objectWithoutPropertiesLoose(params, _excluded5);
    var data = encryptParams(_extends({
      email: email,
      password: password
    }, extra_params), ['email', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_SSO.EMAIL_ACTIVATE_CODE_URL,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  /**
   * [send a verification code to email v2]
   * @param {string} email the email used to verify
   * @param {number} ect_type type
   * @param {string} next direct url
   * @param {string} password password
   * @return {Promise} send result
   */
  this.baseSendEmailCodeV2 = function (params) {
    var email = params.email,
      password = params.password,
      extra_params = _objectWithoutPropertiesLoose(params, _excluded6);
    var data = encryptParams(_extends({
      email: email,
      password: password
    }, extra_params), ['email', 'password']);
    return new Promise(function (resolve, reject) {
      _this.request({
        url: WEB_SSO.EMAIL_ACTIVATE_CODE_URL_V2,
        method: 'POST',
        data: data
      }).then(function (data) {
        resolve(data);
      })["catch"](function (e) {
        reject(e);
      });
    });
  };
  var request = props.request;
  this.request = request;
};

var _excluded$c = ["extra_params"],
  _excluded2$7 = ["extra_params"],
  _excluded3$3 = ["mobile", "code", "extra_params"];
var BindMobileService = /*#__PURE__*/function (_CommonService) {
  _inheritsLoose(BindMobileService, _CommonService);
  function BindMobileService() {
    var _this;
    _this = _CommonService.apply(this, arguments) || this;
    /**
     * [get mobile verification code] out-of-date
     * @param {string} mobile the mobile used to login
     * @return {Promise} send result
     */
    _this.sendMobileCode = function (params) {
      var _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params,
        rest = _objectWithoutPropertiesLoose(params, _excluded$c);
      return _this.baseSendMobileCode(_extends({}, rest, {
        type: 8
      }, extra_params));
    };
    /**
     * [get mobile verification code V2]
     * @param {string} mobile the mobile used to login
     * @return {Promise} send result
     */
    _this.sendMobileCodeV2 = function (params) {
      var _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2,
        rest = _objectWithoutPropertiesLoose(params, _excluded2$7);
      return _this.baseSendMobileCodeV2(_extends({}, rest, {
        type: 8
      }, extra_params));
    };
    /**
     * [bind mobile]
     * @param {string} mobile mobile number
     * @param {string} code verify code
     * @param {number} unbind_exist
     */
    _this.mobileBind = function (params) {
      var mobile = params.mobile,
        code = params.code,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3,
        rest = _objectWithoutPropertiesLoose(params, _excluded3$3);
      var data = encryptParams(_extends({
        mobile: mobile,
        code: code
      }, rest, {
        type: 8
      }, extra_params), ['mobile', 'type', 'code']);
      return _this.request({
        url: WEB_SSO.BIND_MOBILE,
        method: 'POST',
        data: data
      });
    };
    return _this;
  }
  return BindMobileService;
}(CommonService);

var _excluded$d = ["extra_params"],
  _excluded2$8 = ["extra_params"],
  _excluded3$4 = ["mobile", "code", "extra_params"];
// Not Enabled
var ChangeMobileService = /*#__PURE__*/function (_CommonService) {
  _inheritsLoose(ChangeMobileService, _CommonService);
  function ChangeMobileService() {
    var _this;
    _this = _CommonService.apply(this, arguments) || this;
    /**
     * [get mobile verification code] out-of-date
     * @param {string} mobile the mobile used to login
     * @return {Promise} send result
     */
    _this.sendMobileCode = function (params) {
      var _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params,
        rest = _objectWithoutPropertiesLoose(params, _excluded$d);
      return _this.baseSendMobileCode(_extends({}, rest, {
        type: 20
      }, extra_params));
    };
    /**
     * [get mobile verification code V2]
     * @param {string} mobile the mobile used to login
     * @return {Promise} send result
     */
    _this.sendMobileCodeV2 = function (params) {
      var _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2,
        rest = _objectWithoutPropertiesLoose(params, _excluded2$8);
      return _this.baseSendMobileCodeV2(_extends({}, rest, {
        type: 20
      }, extra_params));
    };
    /**
     * [update bind mobile number]
     * @param {string} mobile new mobile
     * @param {string} code verifyCode
     */
    _this.mobileChange = function (params) {
      var mobile = params.mobile,
        code = params.code,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3,
        rest = _objectWithoutPropertiesLoose(params, _excluded3$4);
      var data = encryptParams(_extends({
        mobile: mobile,
        code: code
      }, rest, extra_params), ['mobile', 'code']);
      return _this.request({
        url: WEB_SSO.CHANGE_MOBILE,
        method: 'POST',
        data: data
      });
    };
    return _this;
  }
  return ChangeMobileService;
}(CommonService);

var _excluded$e = ["extra_params"],
  _excluded2$9 = ["extra_params"],
  _excluded3$5 = ["extra_params"],
  _excluded4$1 = ["extra_params"],
  _excluded5$1 = ["extra_params"],
  _excluded6$1 = ["extra_params"];
var LoginService = /*#__PURE__*/function (_CommonService) {
  _inheritsLoose(LoginService, _CommonService);
  function LoginService(props) {
    var _this;
    _this = _CommonService.call(this, props) || this;
    /**
     * [check login status]
     * @param {string} service redirect url after login success
     * @return {Promise} login result
     */
    _this.checkLogin = function (params) {
      var _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params,
        rest = _objectWithoutPropertiesLoose(params, _excluded$e);
      return _this.request({
        url: WEB_SSO.CHECK_LOGIN,
        method: 'GET',
        data: _extends({}, rest, extra_params)
      });
    };
    // /**
    //  * [get mobile verification code] out-of-date
    //  * @param {string} mobile the mobile used to login
    //  * @return {Promise} send result
    //  */
    // public sendMobileCode(params: { mobile: string }): Promise<any> {
    //   return this.baseSendMobileCode({
    //     ...params,
    //     type: 24,
    //   });
    // }
    /**
     * [get mobile verification code V2]
     * @param {string} mobile the mobile used to login
     * @return {Promise} send result
     */
    _this.sendMobileCodeV2 = function (params) {
      var _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2,
        rest = _objectWithoutPropertiesLoose(params, _excluded2$9);
      return _this.baseSendMobileCodeV2(_extends({}, rest, {
        type: 24
      }, extra_params));
    };
    // /**
    //  * [quick authentication] out-of-date
    //  * @param {string} mobile the mobile used to login
    //  * @param {number} service redirect url after login success
    //  * @return {Promise} send result
    //  */
    // public quickAuth(params: { service: string; mobile: string }): Promise<any> {
    //   let { mobile, ...extra_params } = params;
    //   const data = encryptParams({ mobile, ...extra_params }, ['mobile']);
    //   return new Promise((resolve, reject) => {
    //     this.request({
    //       url: WEB_SSO.MOBILE_CODE_LOGIN_URL,
    //       method: 'POST',
    //       data,
    //     })
    //       .then((data: any) => {
    //         resolve(data);
    //       })
    //       .catch((e: any) => {
    //         reject(e);
    //       });
    //   });
    // }
    /**
     * [quick authentication V2]sso 登录+注册
     * @param {string} mobile the mobile used to login
     * @param {string} code corresponding code
     * @param {number} service redirect url after login success
     * @return {Promise} send result
     */
    _this.quickAuthV2 = function (params) {
      var mobile = params.mobile,
        code = params.code,
        service = params.service,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
      var data = encryptParams(_extends({
        mobile: mobile,
        code: code,
        service: service
      }, extra_params), ['mobile', 'code', 'password']);
      return _this.request({
        url: WEB_SSO.MOBILE_CODE_LOGIN_URL_V2,
        method: 'POST',
        data: data
      });
    };
    /**
     * [quick authentication V2]sso 仅登录
     * @param {string} mobile the mobile used to login
     * @param {string} code corresponding code
     * @param {number} service redirect url after login success
     * @return {Promise} send result
     */
    _this.quickAuthLoginOnly = function (params) {
      var mobile = params.mobile,
        code = params.code,
        service = params.service,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
      var data = encryptParams(_extends({
        mobile: mobile,
        code: code,
        service: service
      }, extra_params), ['mobile', 'code']);
      return _this.request({
        url: WEB_SSO.MOBILE_CODE_LOGIN_ONLY_URL,
        method: 'POST',
        data: data
      });
    };
    // /**
    //  * [login by account] out-of-date
    //  * @param {string} account account
    //  * @param {string} password password
    //  */
    // public accountLogin(params: { account: string; password: string }) {
    //   let { account, password, ...extra_params } = params;
    //   const data = encryptParams({ account, password, ...extra_params }, [
    //     'account',
    //     'password',
    //   ]);
    //   return new Promise((resolve, reject) => {
    //     this.request({
    //       url: WEB_SSO.ACCOUNT_LOGIN_URL,
    //       method: 'POST',
    //       data,
    //     })
    //       .then((data: any) => {
    //         resolve(data);
    //       })
    //       .catch((e: any) => {
    //         reject(e);
    //       });
    //   });
    // }
    /**
     * [login by account V2]
     * @param {string} account account
     * @param {number} account_type account type 1: username 2: email 3: phone number
     * @param {string} password password
     * @param {string} service redirect url after successful login
     */
    _this.accountLoginV2 = function (params) {
      var account = params.account,
        password = params.password,
        service = params.service,
        _params$account_type = params.account_type,
        account_type = _params$account_type === void 0 ? 0 : _params$account_type,
        _params$extra_params5 = params.extra_params,
        extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5;
      var data = encryptParams(_extends({
        account: account,
        password: password,
        account_type: account_type,
        service: service
      }, extra_params), ['account', 'password']);
      return _this.request({
        url: WEB_SSO.ACCOUNT_LOGIN_URL_V2,
        method: 'POST',
        data: data
      });
    };
    /**
     * [login by account V2]
     * @param {string} account account
     * @param {number} account_type account type 1: username 2: email 3: phone number
     * @param {string} password password
     * @param {string} service redirect url after successful login
     */
    _this.accountLoginV3 = function (params) {
      var account = params.account,
        password = params.password,
        service = params.service,
        _params$account_type2 = params.account_type,
        account_type = _params$account_type2 === void 0 ? 0 : _params$account_type2,
        _params$extra_params6 = params.extra_params,
        extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
      var data = encryptParams(_extends({
        account: account,
        password: password,
        account_type: account_type,
        service: service
      }, extra_params), ['account', 'password']);
      return _this.request({
        url: WEB_SSO.ACCOUNT_LOGIN_URL_V3,
        method: 'POST',
        data: data
      });
    };
    /**
     * [logout]
     * @param {string} service redirect url after login success
     */
    _this.logout = function (params) {
      var service = params.service;
      window.location.href = "" + _this.host + WEB_SSO.LOGOUT + "?service=" + service;
    };
    /**
     * [wap login]
     * @param {string} origin request domain, this interface isn't sso
     * @param {string} platform_app_id the thrid appId
     * @param {string} next rederict url
     * @param {string} type default 'sso'
     * @param {string} use_local_host default 1
     * @param {string} scopes default 'user_info'
     * @param {string} url_params
     */
    _this.wapLogin = function (params) {
      var _params$origin = params.origin,
        origin = _params$origin === void 0 ? '' : _params$origin,
        _params$type = params.type,
        type = _params$type === void 0 ? 'sso' : _params$type,
        use_local_host = params.use_local_host,
        _params$scopes = params.scopes,
        scopes = _params$scopes === void 0 ? 'user_info' : _params$scopes,
        next = params.next,
        _params$url_params = params.url_params,
        url_params = _params$url_params === void 0 ? '' : _params$url_params,
        platform_app_id = params.platform_app_id,
        _params$platform = params.platform,
        platform = _params$platform === void 0 ? '' : _params$platform,
        _params$replace = params.replace,
        replace = _params$replace === void 0 ? false : _params$replace;
      var service = encodeURIComponent(next);
      var realNext = encodeURIComponent(_this.host + '/auth/login_success/?service=' + service);
      var paramMap = {
        aid: _this.aid,
        type: type,
        use_local_host: use_local_host,
        scopes: scopes,
        next: realNext,
        url_params: url_params,
        platform_app_id: platform_app_id,
        platform: platform
      };
      var query = '';
      var len = Object.keys(paramMap).length;
      Object.keys(paramMap).forEach(function (key, index) {
        if (len === index + 1) {
          query += key + "=" + paramMap[key];
        } else {
          query += key + "=" + paramMap[key] + "&";
        }
      });
      var redirectUrl = "" + origin + WEB_SSO.AUTH_LOGIN_URL + "?" + query;
      // open url in current window
      if (replace) {
        window.location.href = redirectUrl;
      } else {
        // TODO
        var childWindow = window.open(redirectUrl, '_blank');
      }
    };
    /**
     * [send a verification url to email] out-of-date
     * @param {string} email email
     * @param {string} next redirect url after login success
     */
    _this.sendEmailLink = function (params) {
      var _params$extra_params7 = params.extra_params,
        extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7,
        rest = _objectWithoutPropertiesLoose(params, _excluded3$5);
      return _this.baseSendEmailLink(_extends({}, rest, {
        ect_type: 13
      }, extra_params));
    };
    /**
     * [send a verification url to email V2]
     * @param {string} email email
     * @param {string} next redirect url after login success
     */
    _this.sendEmailLinkV2 = function (params) {
      var _params$extra_params8 = params.extra_params,
        extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8,
        rest = _objectWithoutPropertiesLoose(params, _excluded4$1);
      return _this.baseSendEmailLinkV2(_extends({}, rest, {
        ect_type: 13
      }, extra_params));
    };
    /**
     * [send a verification code to email] out-of-date
     * @param {string} email email
     * @param {string} next redirect url after login success
     */
    _this.sendEmailCode = function (params) {
      var _params$extra_params9 = params.extra_params,
        extra_params = _params$extra_params9 === void 0 ? {} : _params$extra_params9,
        rest = _objectWithoutPropertiesLoose(params, _excluded5$1);
      return _this.baseSendEmailCode(_extends({}, rest, {
        ect_type: 13
      }, extra_params));
    };
    /**
     * [send a verification code to email V2]
     * @param {string} email email
     * @param {string} next redirect url after login success
     */
    _this.sendEmailCodeV2 = function (params) {
      var _params$extra_params10 = params.extra_params,
        extra_params = _params$extra_params10 === void 0 ? {} : _params$extra_params10,
        rest = _objectWithoutPropertiesLoose(params, _excluded6$1);
      return _this.baseSendEmailCodeV2(_extends({}, rest, {
        ect_type: 13
      }, extra_params));
    };
    /**
     * [third party login with mobile]
     * @param {string} code authorization code
     * @param {string} profile_key user label
     * @param {number} platform_app_id the thrid appId
     * @param {number} change_bind whether rebind forcely when conflict occurs
     * @param {string} service redirect url after successful login
     */
    _this.bindWithMobileLogin = function (params) {
      var code = params.code,
        platform_app_id = params.platform_app_id,
        service = params.service,
        profile_key = params.profile_key,
        _params$change_bind = params.change_bind,
        change_bind = _params$change_bind === void 0 ? 0 : _params$change_bind,
        _params$extra_params11 = params.extra_params,
        extra_params = _params$extra_params11 === void 0 ? {} : _params$extra_params11;
      return _this.request({
        url: WEB_SSO.BIND_WITH_MOBILE_LOGIN,
        method: 'POST',
        data: _extends({
          code: code,
          platform_app_id: platform_app_id,
          service: service,
          profile_key: profile_key,
          change_bind: change_bind
        }, extra_params)
      });
    };
    /**
     * [third party login with mobile]
     * @param {string} code authorization code
     * @param {number} platform_app_id the thrid appId
     * @param {string} profile_key user label
     * @param {boolean} login_only - 'true' for only login, 'false' for register and login
     * @param {string} service redirect url after successful login
     */
    _this.authLogin = function (params) {
      var code = params.code,
        platform_app_id = params.platform_app_id,
        service = params.service,
        profile_key = params.profile_key,
        _params$login_only = params.login_only,
        login_only = _params$login_only === void 0 ? false : _params$login_only,
        _params$extra_params12 = params.extra_params,
        extra_params = _params$extra_params12 === void 0 ? {} : _params$extra_params12;
      return _this.request({
        url: login_only ? WEB_SSO.AUTH_LOGIN_ONLY : WEB_SSO.AUTH_LOGIN,
        method: 'POST',
        data: _extends({
          code: code,
          platform_app_id: platform_app_id,
          service: service,
          profile_key: profile_key
        }, extra_params)
      });
    };
    /**
     * @param {string} mobile - the mobile used to login
     * @param {string} sms_code - the sms captcha
     * @param {string} email - the email used to login
     * @param {string} email_code - the email captcha
     * @param {string} password - corresponding password
     * @param {string} verify_ticket - the ticket returned by server during last verification process
     * @return {Promise} register result
     */
    _this.mobileEmailRegister = function (params) {
      var mobile = params.mobile,
        sms_code = params.sms_code,
        email = params.email,
        email_code = params.email_code,
        password = params.password,
        verify_ticket = params.verify_ticket,
        service = params.service,
        _params$extra_params13 = params.extra_params,
        extra_params = _params$extra_params13 === void 0 ? {} : _params$extra_params13;
      var data = encryptParams(_extends({
        mobile: mobile,
        sms_code: sms_code,
        email: email,
        email_code: email_code,
        password: password,
        verify_ticket: verify_ticket,
        service: service,
        sms_type: 16,
        ect_type: 1
      }, extra_params), ['mobile', 'sms_code', 'sms_type', 'email', 'email_code', 'ect_type', 'password']);
      return _this.request({
        url: WEB_SSO.MOBILE_EMAIL_REGISTER,
        method: 'POST',
        data: data
      });
    };
    /**
     * [Industry account user switching SSO]
     * @param {string} Industry account system userIdentityId
     */
    _this.memberSwitch = function (params) {
      var to_sec_member_id = params.to_sec_member_id,
        _params$extra_params14 = params.extra_params,
        extra_params = _params$extra_params14 === void 0 ? {} : _params$extra_params14;
      return _this.request({
        url: SSO_AFF_URL.MEMBER_SWITCH,
        method: 'POST',
        data: _extends({
          to_sec_member_id: to_sec_member_id
        }, extra_params)
      });
    };
    var host = props.host,
      originHost = props.originHost,
      aid = props.aid;
    _this.aid = aid;
    _this.host = host;
    _this.originHost = originHost;
    return _this;
  }
  return LoginService;
}(CommonService);

var _excluded$f = ["extra_params"],
  _excluded2$a = ["extra_params"];
var PasswordService = /*#__PURE__*/function (_CommonService) {
  _inheritsLoose(PasswordService, _CommonService);
  function PasswordService() {
    var _this;
    // /**
    //  * [get mobile verification code] out-of-date
    //  * @param {string} mobile the mobile used to login
    //  * @return {Promise} send result
    //  */
    // public sendMobileCode(params: { mobile: string }): Promise<any> {
    //   return this.baseSendMobileCode({
    //     ...params,
    //     type: 6,
    //   });
    // }
    _this = _CommonService.apply(this, arguments) || this;
    /**
     * [get mobile verification code V2]
     * @param {string} mobile the mobile used to login
     * @param {string} check_register whether need to check register
     * @return {Promise} send result
     */
    _this.sendMobileCodeV2 = function (params) {
      var mobile = params.mobile,
        _params$check_registe = params.check_register,
        check_register = _params$check_registe === void 0 ? false : _params$check_registe,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
      return _this.baseSendMobileCodeV2(_extends({
        mobile: mobile,
        type: check_register ? 4 : 6
      }, extra_params));
    };
    // /**
    //  * [send a verification url to email] out-of-date
    //  * @param {string} email email
    //  * @param {string} next redirect url after login success
    //  * @param {string} password password
    //  */
    // public sendEmailCode(params: {
    //   email: string;
    //   next?: string;
    //   password?: string;
    // }): Promise<any> {
    //   let { email, password, ...extra_params } = params;
    //   const data = encryptParams(
    //     { email, password, ect_type: 4, ...extra_params },
    //     ['email', 'password']
    //   );
    //   return new Promise((resolve, reject) => {
    //     this.request({
    //       url: WEB_SSO.SSO_EMAIL_ACTIVATE_CODE_URL,
    //       method: 'POST',
    //       data,
    //     })
    //       .then((data: any) => {
    //         resolve(data);
    //       })
    //       .catch((e: any) => {
    //         reject(e);
    //       });
    //   });
    // }
    /**
     * [send a verification url to email V2]
     * @param {string} email email
     * @param {string} next redirect url after login success
     * @param {string} password password
     */
    _this.sendEmailCodeV2 = function (params) {
      var _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2,
        rest = _objectWithoutPropertiesLoose(params, _excluded$f);
      return _this.baseSendEmailCodeV2(_extends({}, rest, {
        ect_type: 4
      }, extra_params));
    };
    /**
     * [reset password]
     * @param {string} account account
     * @param {string} code verify code
     * @param {string} password new password
     */
    _this.resetPassword = function (params) {
      var account = params.account,
        code = params.code,
        password = params.password,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3;
      var data = encryptParams({
        account: account,
        code: code,
        password: password
      }, ['account', 'code', 'password']);
      return new Promise(function (resolve, reject) {
        _this.request({
          url: WEB_SSO.RESET_PASSWORD,
          method: 'POST',
          data: _extends({}, data, extra_params)
        }).then(function (data) {
          resolve(data);
        })["catch"](function (e) {
          reject(e);
        });
      });
    };
    /**
     * [modify password by email code]
     * @param email
     * @param code
     * @param password
     * @param extra_params
     * @returns
     */
    _this.resetPasswordByEmailCode = function (params) {
      var email = params.email,
        code = params.code,
        password = params.password,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4;
      var data = encryptParams({
        email: email,
        code: code,
        password: password
      }, ['email', 'code', 'password']);
      return _this.request({
        url: WEB_SSO.RESET_PASSWORD_BY_EMAIL,
        method: 'POST',
        data: _extends({}, data, {
          ect_type: 4
        }, extra_params)
      });
    };
    /**
     * [send a verification url to email V2]
     * @param {string} email email
     * @param {string} next redirect url after login success
     * @param {string} password password
     */
    _this.sendEmailCodeModifyPassword = function (params) {
      if (params === void 0) {
        params = {};
      }
      var _params = params,
        _params$extra_params5 = _params.extra_params,
        extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5,
        rest = _objectWithoutPropertiesLoose(_params, _excluded2$a);
      return _this.baseSendEmailCodeV2(_extends({}, rest, {
        ect_type: 11
      }, extra_params));
    };
    /**
     * [modify password by email code]
     * @param email
     * @param code
     * @param password
     * @param extra_params
     * @returns
     */
    _this.modifyPasswordByEmailCode = function (params) {
      var email = params.email,
        code = params.code,
        password = params.password,
        _params$extra_params6 = params.extra_params,
        extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6;
      var data = encryptParams({
        email: email,
        code: code,
        password: password
      }, ['email', 'code', 'password']);
      return _this.request({
        url: WEB_SSO.RESET_PASSWORD_BY_EMAIL,
        method: 'POST',
        data: _extends({}, data, {
          ect_type: 11
        }, extra_params)
      });
    };
    /**
     * [登录态下设置密码]
     * @param password
     * @param extra_params
     * @returns
     */
    _this.setPassword = function (params) {
      var password = params.password,
        _params$extra_params7 = params.extra_params,
        extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7;
      var data = encryptParams({
        password: password
      }, ['password']);
      return _this.request({
        url: WEB_SSO.SET_PASWORD,
        method: 'POST',
        data: _extends({}, data, extra_params)
      });
    };
    return _this;
  }
  return PasswordService;
}(CommonService);

var QrCodeService = /*#__PURE__*/function (_CommonService) {
  _inheritsLoose(QrCodeService, _CommonService);
  function QrCodeService() {
    var _this;
    _this = _CommonService.apply(this, arguments) || this;
    /**
     * [get qrcode url]
     * @param {string} service redirect url after login success
     */
    _this.getQrcode = function (params) {
      var service = params.service,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
      return _this.request({
        // WARNING: axios can encodeURL
        url: WEB_SSO.GET_QRCODE + "?service=" + encodeURIComponent(service),
        method: 'GET',
        data: extra_params
      });
    };
    /**
     * [query qrCode status]
     * @param {string} service redirect url after login success
     * @param {string} token result of GetQrcode
     */
    _this.checkQrconnect = function (params) {
      var service = params.service,
        token = params.token,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2;
      return _this.request({
        // WARNING: axios can encodeURL
        url: WEB_SSO.CHECK_QRCONNECT + "?service=" + encodeURIComponent(service),
        method: 'GET',
        data: _extends({
          // service,
          token: token
        }, extra_params)
      });
    };
    return _this;
  }
  return QrCodeService;
}(CommonService);

var _excluded$g = ["extra_params"],
  _excluded2$b = ["extra_params"],
  _excluded3$6 = ["code", "extra_params"];
var QuickAuthService = /*#__PURE__*/function (_CommonService) {
  _inheritsLoose(QuickAuthService, _CommonService);
  function QuickAuthService() {
    var _this;
    _this = _CommonService.apply(this, arguments) || this;
    /**
     * [get mobile verification code] out-of-date
     * @param {string} mobile the mobile used to login
     * @return {Promise} send result
     */
    _this.sendMobileCode = function (params) {
      var _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params,
        rest = _objectWithoutPropertiesLoose(params, _excluded$g);
      return _this.baseSendMobileCode(_extends({}, rest, {
        type: 22
      }, extra_params));
    };
    /**
     * [get mobile verification code V2]
     * @param {string} mobile the mobile used to login
     * @return {Promise} send result
     */
    _this.sendMobileCodeV2 = function (params) {
      var _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2,
        rest = _objectWithoutPropertiesLoose(params, _excluded2$b);
      return _this.baseSendMobileCodeV2(_extends({}, rest, {
        type: 22
      }, extra_params));
    };
    /**
     * [quick auth by mobile]
     * @param {string} service redirect url after login success
     * @param {string} code mobile verify code
     */
    _this.quickAuth = function (params) {
      var code = params.code,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3,
        rest = _objectWithoutPropertiesLoose(params, _excluded3$6);
      var data = encryptParams(_extends({
        code: code
      }, rest, extra_params), ['code']);
      return _this.request({
        url: WEB_SSO.QUICK_AUTH,
        method: 'POST',
        data: data
      });
    };
    return _this;
  }
  return QuickAuthService;
}(CommonService);

var _excluded$h = ["email", "extra_params"],
  _excluded2$c = ["email", "code", "mobile", "password", "extra_params"],
  _excluded3$7 = ["email", "code", "mobile", "password", "extra_params"],
  _excluded4$2 = ["email", "code", "extra_params"],
  _excluded5$2 = ["extra_params"],
  _excluded6$2 = ["extra_params"],
  _excluded7 = ["extra_params"],
  _excluded8 = ["extra_params"],
  _excluded9 = ["extra_params"],
  _excluded10 = ["extra_params"];
var RegisterService = /*#__PURE__*/function (_CommonService) {
  _inheritsLoose(RegisterService, _CommonService);
  function RegisterService() {
    var _this;
    _this = _CommonService.apply(this, arguments) || this;
    /**
     * [email register xhr]
     * @param {string} params -- requeset body data
     */
    _this.emailRegisterXhr = function (params) {
      return _this.request({
        url: WEB_SSO.EMAIL_REGISTER,
        method: 'POST',
        data: params
      });
    };
    /**
     * [email register]
     * @param {string} email email
     * @param {string} next redirect url after successful registration
     * @param {string} code code
     * @param {string} token token in email verification link
     * @param {string} password account password
     * @param {string} email_logic_type const
     */
    _this.emailRegister = function (params) {
      var email = params.email,
        _params$extra_params = params.extra_params,
        extra_params = _params$extra_params === void 0 ? {} : _params$extra_params,
        rest = _objectWithoutPropertiesLoose(params, _excluded$h);
      var data = encryptParams(_extends({
        email: email
      }, rest, {
        ect_type: 1
      }, extra_params), ['email', 'code', 'password']);
      return _this.emailRegisterXhr(data);
    };
    // /**
    //  * [email register and bind mobile] out-of-date
    //  * @param {string} email email
    //  * @param {string} code code
    //  * @param {string} mobile mobile
    //  * @param {string} password password
    //  */
    // public emailRegisterAndBindMoblie(params: {
    //   email?: string;
    //   code: string;
    //   mobile: string;
    //   password: string;
    // }) {
    //   let { email, code, mobile, password, ...extra_params } = params;
    //   const data = encryptParams(
    //     { email, code, mobile, password, ...extra_params },
    //     ['email', 'code', 'mobile', 'password']
    //   );
    //   return this.emailRegisterXhr(data);
    // }
    /**
     * [email register and bind mobile V2]
     * @param {string} email email
     * @param {string} code code
     * @param {string} mobile mobile
     * @param {string} password password
     */
    _this.emailRegisterAndBindMoblieV2 = function (params) {
      var email = params.email,
        code = params.code,
        mobile = params.mobile,
        password = params.password,
        _params$extra_params2 = params.extra_params,
        extra_params = _params$extra_params2 === void 0 ? {} : _params$extra_params2,
        rest = _objectWithoutPropertiesLoose(params, _excluded2$c);
      var data = encryptParams(_extends({
        email: email,
        code: code,
        mobile: mobile,
        password: password
      }, rest, extra_params), ['email', 'code', 'mobile', 'password']);
      return _this.request({
        url: WEB_SSO.EMAIL_REGISTER_V2,
        method: 'POST',
        data: data
      });
    };
    /**
     * [mobile register and bind email V2]
     * @param {string} email email
     * @param {string} code code
     * @param {string} mobile mobile
     * @param {string} password password
     */
    _this.mobileRegisterAndBindEmailV2 = function (params) {
      var email = params.email,
        code = params.code,
        mobile = params.mobile,
        password = params.password,
        _params$extra_params3 = params.extra_params,
        extra_params = _params$extra_params3 === void 0 ? {} : _params$extra_params3,
        rest = _objectWithoutPropertiesLoose(params, _excluded3$7);
      var data = encryptParams(_extends({
        email: email,
        code: code,
        mobile: mobile,
        password: password
      }, rest, extra_params), ['email', 'code', 'mobile', 'password']);
      return _this.request({
        url: WEB_SSO.MOBILE_REGISTER_WITH_EMAIL,
        method: 'POST',
        data: data
      });
    };
    /**
     * [login by email code]
     * @param {string} email email
     * @param {string} next redierct url
     * @param {string} code verify code
     * @param {string} token verify token
     */
    _this.emailActivateCodeLogin = function (params) {
      var email = params.email,
        code = params.code,
        _params$extra_params4 = params.extra_params,
        extra_params = _params$extra_params4 === void 0 ? {} : _params$extra_params4,
        rest = _objectWithoutPropertiesLoose(params, _excluded4$2);
      var data = encryptParams(_extends({
        email: email,
        code: code
      }, rest, {
        ect_type: 13
      }, extra_params), ['email', 'code']);
      return _this.request({
        url: WEB_SSO.EMAIL_ACTIVATE_CODE_LOGIN,
        method: 'POST',
        data: data
      });
    };
    /**
     * [get mobile verification code] out-of-date
     * @param {string} mobile the mobile used to login
     * @return {Promise} send result
     */
    _this.sendMobileCode = function (params) {
      var _params$extra_params5 = params.extra_params,
        extra_params = _params$extra_params5 === void 0 ? {} : _params$extra_params5,
        rest = _objectWithoutPropertiesLoose(params, _excluded5$2);
      return _this.baseSendMobileCode(_extends({}, rest, {
        type: 16
      }, extra_params));
    };
    /**
     * [get mobile verification code V2]
     * @param {string} mobile the mobile used to login
     * @return {Promise} send result
     */
    _this.sendMobileCodeV2 = function (params) {
      var _params$extra_params6 = params.extra_params,
        extra_params = _params$extra_params6 === void 0 ? {} : _params$extra_params6,
        rest = _objectWithoutPropertiesLoose(params, _excluded6$2);
      return _this.baseSendMobileCodeV2(_extends({}, rest, {
        type: 16
      }, extra_params));
    };
    /**
     * [send a verification url to email] out-of-date
     * @param {string} email the email used to verify
     * @param {number} ect_type type
     * @param {string} next direct url
     * @param {string} password password
     * @return {Promise} send result
     */
    _this.sendEmailLink = function (params) {
      var _params$extra_params7 = params.extra_params,
        extra_params = _params$extra_params7 === void 0 ? {} : _params$extra_params7,
        rest = _objectWithoutPropertiesLoose(params, _excluded7);
      return _this.baseSendEmailLink(_extends({}, rest, {
        ect_type: 1
      }, extra_params));
    };
    /**
     * [send a verification url to email V2]
     * @param {string} email the email used to verify
     * @param {number} ect_type type
     * @param {string} next direct url
     * @param {string} password password
     * @return {Promise} send result
     */
    _this.sendEmailLinkV2 = function (params) {
      var _params$extra_params8 = params.extra_params,
        extra_params = _params$extra_params8 === void 0 ? {} : _params$extra_params8,
        rest = _objectWithoutPropertiesLoose(params, _excluded8);
      return _this.baseSendEmailLinkV2(_extends({}, rest, {
        ect_type: 1
      }, extra_params));
    };
    /**
     * [send a verification code to email] out-of-date
     * @param {string} email the email used to verify
     * @param {number} ect_type type
     * @param {string} next direct url
     * @param {string} password password
     * @return {Promise} send result
     */
    _this.sendEmailCode = function (params) {
      var _params$extra_params9 = params.extra_params,
        extra_params = _params$extra_params9 === void 0 ? {} : _params$extra_params9,
        rest = _objectWithoutPropertiesLoose(params, _excluded9);
      return _this.baseSendEmailCode(_extends({}, rest, {
        ect_type: 1
      }, extra_params));
    };
    /**
     * [send a verification code to email V2]
     * @param {string} email the email used to verify
     * @param {number} ect_type type
     * @param {string} next direct url
     * @param {string} password password
     * @return {Promise} send result
     */
    _this.sendEmailCodeV2 = function (params) {
      var _params$extra_params10 = params.extra_params,
        extra_params = _params$extra_params10 === void 0 ? {} : _params$extra_params10,
        rest = _objectWithoutPropertiesLoose(params, _excluded10);
      return _this.baseSendEmailCodeV2(_extends({}, rest, {
        ect_type: 1
      }, extra_params));
    };
    return _this;
  }
  return RegisterService;
}(CommonService);

var SsoInterface = /*#__PURE__*/function (_BaseInterface) {
  _inheritsLoose(SsoInterface, _BaseInterface);
  function SsoInterface(props) {
    var _this;
    _this = _BaseInterface.call(this, props, 'sso') || this;
    var host = props.host,
      printLog = props.printLog,
      _props$acrawler = props.acrawler,
      acrawler = _props$acrawler === void 0 ? '' : _props$acrawler;
    // log
    if (printLog) {
      console.log('%cSSOInterface Initial Props >>>>%O', 'background: #222; color: #bada55', props);
    }
    // acrawler
    if (acrawler) {
      initAcrawler(acrawler, props);
    }
    // SSO address
    _this.host = host || '';
    // domain address
    _this.originHost = window.location.origin;
    var argus = _extends({}, props, {
      request: _this.request
    });
    _this.bindMobile = new BindMobileService(argus);
    _this.changeMobile = new ChangeMobileService(argus);
    _this.login = new LoginService(_extends({}, argus, {
      originHost: _this.originHost
    }));
    _this.password = new PasswordService(argus);
    _this.qrcodeLogin = new QrCodeService(argus);
    _this.quickAuth = new QuickAuthService(argus);
    _this.register = new RegisterService(argus);
    return _this;
  }
  return SsoInterface;
}(BaseInterface);

var CommonAPI = function CommonAPI(props) {
  var _this = this;
  /**
   * @param {string} mode - mode
   * @param {string} scene - scene
   * @return {Promise} - send result
   */
  this.webSdkInit = function (params) {
    var mode = params.mode,
      scene = params.scene,
      _params$extra_params = params.extra_params,
      extra_params = _params$extra_params === void 0 ? {} : _params$extra_params;
    return _this.request({
      url: AUTH_URL.WEB_SDK_INIT,
      method: 'POST',
      data: _extends({
        mode: mode,
        scene: scene
      }, extra_params)
    });
  };
  var request = props.request;
  this.request = request;
};

var AppInterface$1 = /*#__PURE__*/function (_BaseInterface) {
  _inheritsLoose(AppInterface, _BaseInterface);
  function AppInterface(props) {
    var _this;
    _this = _BaseInterface.call(this, props, 'auth') || this;
    var _props$printLog = props.printLog,
      printLog = _props$printLog === void 0 ? false : _props$printLog,
      _props$acrawler = props.acrawler,
      acrawler = _props$acrawler === void 0 ? '' : _props$acrawler;
    // log
    if (printLog) {
      console.log('AuthInterface Initial Props >>>>', props);
    }
    // acrawler
    if (acrawler) {
      initAcrawler(acrawler, props);
    }
    // web interfaces
    var argus = _extends({}, props, {
      request: _this.request
    });
    _this.common = new CommonAPI(argus);
    return _this;
  }
  return AppInterface;
}(BaseInterface);

var WebInterfaceSdk = WebInterface;
var AppInterfaceSdk = AppInterface;
var SsoInterfaceSdk = SsoInterface;
var AuthInterfaceSdk = AppInterface$1;
var AccountSdk = function AccountSdk(props) {
  var _props$scope = props.scope,
    scope = _props$scope === void 0 ? 'web' : _props$scope;
  switch (scope) {
    case 'web':
      {
        return new WebInterface(props);
      }
    case 'app':
      {
        return new AppInterface(props);
      }
    case 'sso':
      {
        return new SsoInterface(props);
      }
    case 'auth':
      {
        return new AppInterface$1(props);
      }
    default:
      {
        return new WebInterface(props);
      }
  }
};
var SdkType = {
  web: WebInterface,
  app: AppInterface,
  sso: SsoInterface,
  auth: AppInterface$1
};
var SdkInstance = {
  web: null,
  app: null,
  sso: null,
  auth: null
};
var AccountSdkFactory = /*#__PURE__*/function () {
  function AccountSdkFactory() {}
  AccountSdkFactory.createAccountSdk = function createAccountSdk(type, config) {
    var targetType = SdkType[type] || SdkType.web;
    if (SdkInstance[type]) {
      return SdkInstance[type];
    }
    SdkInstance[type] = AccountSdkFactory.create(targetType, config);
    return SdkInstance[type];
  };
  AccountSdkFactory.create = function create(Type, config) {
    return new Type(config);
  };
  return AccountSdkFactory;
}();
var createAccountSdk = AccountSdkFactory.createAccountSdk;
var AccountSdkInstance = createAccountSdk;

export default AccountSdk;
export { AccountSdkInstance, AppInterfaceSdk, AuthInterfaceSdk, SsoInterfaceSdk, WebInterfaceSdk, encryptParams };
//# sourceMappingURL=account-api.esm.js.map
